<mat-card class="stepper">


  <button class="autoFill_Map" mat-stroked-button color="primary" 
    (click)="openMappingSlide()">
    Map
  </button>
  <button class="autoFill_Map" mat-flat-button color="primary" matTooltip="Auto Fill Controls" (click)="fillForms(fillForm)">
    Auto Fill
  </button>

  <div class="allStepWithBack">



    <button mat-flat-button class="saveBtn" color="primary" (click)="SubmitBackButton()" matTooltip="Back"
      matTooltip="Back" matTooltipClass="tooltip">
      Back
      <!-- <mat-icon>arrow_back_ios</mat-icon> -->
    </button>



    <div class="allSteps">




      <div [ngClass]="stepCompleted >0 ? 'active step done' : 'active step'">
        <div class="stepStatus" (click)="showUploadDocuments()">
          <span class="nmbr">1</span>
          <span class="stepName">Upload Document </span>
          <span class="stepIcon">
            <mat-icon>picture_as_pdf</mat-icon>
          </span>
        </div>
      </div>

      <div [ngClass]="stepCompleted >1 ? 'active step done' : 'active step'">
        <div class="stepStatus" (click)="showAllParticipant()">
          <span class="nmbr">2</span>
          <span class="stepName">Add Participant </span>
          <span class="stepIcon">
            <mat-icon>account_box</mat-icon>
          </span>
        </div>
      </div>


      <div [ngClass]="stepCompleted >2 ? 'active step done' : 'active step'">
        <div class="stepStatus" (click)="showFormFinish()">
          <span class="nmbr">3</span>
          <span class="stepName">Design Form </span>
          <span class="stepIcon">
            <mat-icon>design_services</mat-icon>
          </span>
        </div>
      </div>


      <div [ngClass]="stepCompleted >3 ? 'active step done' : 'step'">
        <div class="stepStatus" (click)="showFormFinish()">
          <span class="nmbr">4</span>
          <span class="stepName">Review & Send </span>
          <span class="stepIcon">
            <mat-icon>send</mat-icon>
          </span>
        </div>
      </div>

    </div>


   
    <button mat-flat-button color="primary" matTooltip="Next" [disabled]="!SubmitNextButtonDisabled"
      (click)="SubmitNextButton()">
      Next
    </button>

 

  </div>
  <div class="stepAct">

 
    <div class="saveBtns">
        <button color="primary" style="background-color: rgb(87, 204, 87); color: white" class="saveBtn" mat-flat-button
        matTooltipClass="tooltip" matTooltip="Save" (click)="SaveRecord(false)">
        Save
      </button>

      <button color="primary" class="mlr-10"   mat-stroked-button
      matTooltipClass="tooltip" matTooltip="Save" (click)="SaveRecord(true)">
      Save & Close
    </button> 
    </div>
   

    <button *ngIf="showAdd3CButton" (click)='openConvertPdfPopup(ConvertPdfpopUp)' class="overWeb" color="primary"
      mat-stroked-button matTooltip="Generate PDF">
      Generate PDF
    </button>

    <!-- <button color="primary" style="background-color: rgb(87, 204, 87); color: white"  mat-flat-button
     matTooltipClass="tooltip" matTooltip="Save" (click)="SaveRecord(true)">
     Save & Close
    </button> -->

    <button *ngIf="showAdd3CButton" (click)='openConvertPdfPopup(ConvertPdfpopUp)' class="overdevice" color="primary"
      mat-icon-button matTooltip="Generate PDF">
      <mat-icon>picture_as_pdf</mat-icon>
    </button>
    <!-- <button mat-stroked-button color="primary" (click)="documentPreview(docPreview)">Preview</button> -->

  </div>

</mat-card>

<div class="canvas">

  <mat-card class="lblockPanel" [ngClass]="{ active: showToolsLeft }">
    <mat-tab-group>

      <mat-tab>
        <ng-template mat-tab-label>
          <!-- <mat-icon>construction</mat-icon> -->
           Standard
        </ng-template>
        <div class="allFolder">
          <mat-accordion>
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>
                <mat-panel-title> Main </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ftool">

                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of singlLineWithFields" [dndDraggable]="field" [dndEffectAllowed]="'move'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Textbox')">
                  <mat-icon>power_input</mat-icon>Single-Line
                </mat-card>

                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of multiLineWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Textarea')">
                  <mat-icon>dehaze</mat-icon>Multi-Line
                </mat-card>


                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of numberWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Number')">
                  <mat-icon>filter_1</mat-icon>Number
                </mat-card>

                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of aiBoxWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Number')">
                  <mat-icon>filter_1</mat-icon>AI TextBox
                </mat-card>

                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of radioWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Radio')">
                  <mat-icon>radio_button_checked</mat-icon>Radio
                </mat-card>

                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of dropdownWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Dropdown')">
                  <mat-icon>arrow_drop_down_circle</mat-icon>Dropdown
                </mat-card>

                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of checkWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Checkbox')">
                  <mat-icon>check_box</mat-icon> Check Box
                </mat-card>


                <mat-card (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of checkboxgroupWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('CheckBoxGroup')">
                  <mat-icon>library_add_check</mat-icon> Check Box Group
                </mat-card>

                <mat-card (click)='replaceControl(field)' id='format_list_bulletedleftpanel'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of bulletWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('BulletList')">
                  <mat-icon>format_list_bulleted</mat-icon>Bullet List
                </mat-card>

                <mat-card (click)='replaceControl(field)' id='table_chartleftpanel'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of tableWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Table')">
                  <mat-icon>table_chart</mat-icon>Table
                </mat-card>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> Markup </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ftool">
                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of strikeThroughWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('StrikeThrough')">
                  <mat-icon>strikethrough_s</mat-icon>Strike Through
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of WhiteOutWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('WhiteOut')">
                  <mat-icon>outbond</mat-icon>White Out
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of HighlightFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('HighLight')">
                  <mat-icon>highlight_alt</mat-icon>Highlight
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of drawWithFields"
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"
                  (click)="OpentoolDetail('Draw')">
                  <mat-icon>brush</mat-icon>Draw
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of MeasureWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('measure')">
                  <mat-icon>straighten</mat-icon>Measure
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool" (click)="OpentoolDetail('line')"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" class="tool"
                  *ngFor="let field of straightLineWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)">
                  <mat-icon>minimize</mat-icon>Straight line
                </mat-card>
                <!-- <mat-card class="tool"  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of drawInPopUp" [dndDraggable]="field"
                [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"  (click)="OpentoolDetail('Draw')">
                  <mat-icon>brush</mat-icon>Draw
                </mat-card> -->
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> Dates & Signature </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ftool">
                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
                  *ngFor="let field of signatureWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Signature')">
                  <mat-icon>create</mat-icon>Signature
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
                  *ngFor="let field of initialsWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('Initials')">
                  <mat-icon>gesture</mat-icon>Initials
                </mat-card>

                <!-- <mat-card class="tool" [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of ApproveOrDeclineWithFields" [dndDraggable]="field"
                [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"  (click)="OpentoolDetail('ApproveOrDecline')">
                  <mat-icon>done</mat-icon> Approval
                </mat-card> -->

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of dateWithFields"
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"
                  (click)="OpentoolDetail('Date')">
                  <mat-icon>event_available</mat-icon>Date
                </mat-card>
                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of timeWithFields"
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"
                  (click)="OpentoolDetail('Time')">
                  <mat-icon>schedule</mat-icon>Time
                </mat-card>
                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
                  *ngFor="let field of LocationWithFields" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)" (click)="OpentoolDetail('location')">
                  <mat-icon>location_on</mat-icon>Location
                </mat-card>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> Misc </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="ftool">
                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of fileWithFields"
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"
                  (click)="OpentoolDetail('File')">
                  <mat-icon>insert_drive_file</mat-icon>File
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor=" let field of imageWithFields"
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"
                  (click)="OpentoolDetail('Image')">
                  <mat-icon>wallpaper</mat-icon>Image
                </mat-card>

                <mat-card (click)='replaceControl(field)' class="tool"
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor="let field of buttonWithFields"
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)"
                  (click)="OpentoolDetail('Button')">
                  <mat-icon>smart_button</mat-icon>Button
                </mat-card>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>
      </mat-tab>

      <mat-tab *ngIf="showAdd3CButton">
        <ng-template mat-tab-label>
          <!-- <svg xmlns="http://www.w3.org/2000/svg" width="33" height="17.999" viewBox="0 0 33 16.999">
            <path class="customFieldIcon" id="Subtraction_1" data-name="Subtraction 1"
              d="M31,16.5H2A1.5,1.5,0,0,1,.5,15V2A1.5,1.5,0,0,1,2,.5H31A1.5,1.5,0,0,1,32.5,2V15A1.5,1.5,0,0,1,31,16.5ZM6.072,4.469V13H7.2V4.469Z"
              transform="translate(0 0)" fill="none" stroke="#e0e0e0" stroke-width="2" />
          </svg> -->
          Custom
        </ng-template>

        <div class="allFolder">
          <mat-accordion>
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> <mat-icon>app_registration</mat-icon>&nbsp; {{CoreName}} </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="customFields">
                <!-- <button mat-icon-button >
                  <mat-icon>add</mat-icon>
                </button> -->

                <button mat-mini-fab (click)="createField('Core')" class="addField" color="primary" >
                  <mat-icon>add</mat-icon>
                </button>

                <mat-form-field appearance="fill">
                  <mat-label>Select Type</mat-label>
                  <mat-select (selectionChange)="getAllCoreSubfolderFields($event.value)" name="selectedCorePeopleType">
                    <mat-option *ngFor="let subFolder of coreSubFolderList" [value]="subFolder.subFolderID">
                      {{ subFolder.folderName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-card class="field" (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor=" let field of corefieldsList "
                  [dndDraggable]="field" [dndEffectAllowed]="'copy'" (dndEnd)="onDragEnd($event)">
                  <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
                </mat-card>
              </div>
            </mat-expansion-panel>

            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> <mat-icon>business</mat-icon> &nbsp;{{CompanyName}} </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="customFields">
                <!-- <button mat-icon-button class="addField" color="primary" (click)="createField('Company')">
                  <mat-icon>add</mat-icon>
                </button> -->

                <button mat-mini-fab (click)="createField('Company')" class="addField" color="primary" >
                  <mat-icon>add</mat-icon>
                </button>

                <mat-form-field appearance="fill">
                  <mat-label>Select Type</mat-label>
                  <mat-select (selectionChange)="getAllCompanySubfolderFields($event.value)"
                    name="selectedCompanyPeopleType">
                    <mat-option *ngFor="let subFolder of companySubFolderList" [value]="subFolder.subFolderID">
                      {{ subFolder.folderName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-card class="field" (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
                  *ngFor=" let field of companyfieldsList" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)">
                  <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
                </mat-card>

              </div>
            </mat-expansion-panel>


            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title> <mat-icon>contact_mail</mat-icon>&nbsp; {{ContactName}} </mat-panel-title>
              </mat-expansion-panel-header>

              <div class="customFields">
                <!-- <button mat-icon-button class="addField" color="primary" (click)="createField('Contact')">
                  <mat-icon>add</mat-icon>
                </button> -->

                <button mat-mini-fab (click)="createField('Contact')" class="addField" color="primary" >
                  <mat-icon>add</mat-icon>
                </button>

                <mat-form-field appearance="fill">
                  <mat-label>Select Type</mat-label>
                  <mat-select (selectionChange)="getAllContactSubfolderFields($event.value)"
                    name="selectedCompanyPeopleType">
                    <mat-option *ngFor="let subFolder of contactSubFolderList" [value]="subFolder.subFolderID">
                      {{ subFolder.folderName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>


                <mat-card class="field" (click)='replaceControl(field)'
                  [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}"
                  *ngFor=" let field of contactfieldsList" [dndDraggable]="field" [dndEffectAllowed]="'copy'"
                  (dndEnd)="onDragEnd($event)">
                  <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
                </mat-card>

              </div>
            </mat-expansion-panel>

          </mat-accordion>
        </div>
      </mat-tab>


    </mat-tab-group>
  </mat-card>
  <!-- <div class="overlay" [ngClass]="{ active: showToolsLeft }" (click)="showTools()"></div> -->

  <div class="formWrapper">
    <mat-card class="toolHolder">


      <!-- <button *ngIf="showAdd3CButton" class="autoFill_Web" mat-icon-button matTooltip="Auto Fill Controls"
        (click)="fillForms(fillForm)">
        <mat-icon>note_alt</mat-icon>
      </button> -->


      <!-- <button *ngIf="showBindField" class="globalAiBtn topAiBtn" color="" matTooltip="Feild Mapping"
        (click)="openAIBinding()">
        <span>AI</span>
      </button> -->

      <button color="primary" class="globalAiBtn mt-8" matTooltipClass="tooltip" matTooltip="AI"
       (click)="openAIPdfPopup(AIPdfpopUp)">
       <span>AI</span>
      </button>

      <button mat-icon-button color="" matTooltip="Hide AI Editor"
        (click)="hideControls()"><mat-icon>filter_1</mat-icon></button>

      <button mat-icon-button matTooltip="Show PlaceHolder Names" (click)="showAllPlaceHolderNames()">
        <mat-icon>remove_red_eye</mat-icon>
      </button>

      <button mat-icon-button matTooltip="Copy" (click)="CopyCntrl()">
        <mat-icon>content_copy</mat-icon>
      </button>
      <!-- *ngIf="controlId2Paste!=''" -->
      <ng-container>
        <button [disabled]="controlId2Paste==''" mat-icon-button matTooltip="Paste" (click)="pasterCtrl()">
          <mat-icon>content_paste</mat-icon>
        </button>
      </ng-container>

      <div class="sepreator"></div>

      <!-- library_add_check -->
      <button mat-icon-button matTooltip="Select All Controls" (click)="SelectAllControls()">
        <mat-icon>select_all</mat-icon>
      </button>
      <!-- <button mat-icon-button >
        <mat-icon>snippet_folder</mat-icon>
      </button>
      <button mat-icon-button>
        <mat-icon>local_library</mat-icon>
      </button> -->
      <div class="sepreator"></div>
      <button mat-icon-button matTooltip="Required Controls" id="chkverified"
        (click)="highlightRequiredControls(!isverifiedIconEnabled)">
        <mat-icon>verified</mat-icon>
      </button>
      <div class="sepreator aligntool"></div>
      <button class="aligntool" (click)='hideTableAndBulletList(isClickReplaceEnabled,!isClickReplaceEnabled)'
        mat-icon-button matTooltip="Select and start to replace contorls" id="chkReplace">
        <mat-icon>published_with_changes</mat-icon>
      </button>
      <div class="sepreator autoFill_Mobile"></div>
      <!-- <button  (click)='openConvertPdfPopup(ConvertPdfpopUp)'  mat-icon-button matTooltip="Generate PDF" >
        <mat-icon>picture_as_pdf</mat-icon>
      </button> -->
      <!-- <button *ngIf="isClickReplaceEnabled===true" (click)='hideTableAndBulletList(isClickReplaceEnabled)'  mat-icon-button matTooltip="Select and start to replace contorls" id="chkReplace">
        <mat-icon>published_with_changes</mat-icon>
      </button> -->

      <button *ngIf="showAdd3CButton" class="autoFill_Mobile" mat-icon-button color="basic"
        matTooltip="Auto Fill Controls" (click)="fillForms(fillForm)">
        <mat-icon>note_alt</mat-icon>
      </button>


      <ng-container *ngIf="controlAlignArray?.length>0">
        <div class="sepreator"></div>
        <button mat-icon-button color="warn" matTooltip="Delete Controls" (click)="deleteControls()">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </ng-container>




      <div class="sepreator"></div>

     
      <div class="highlight" *ngIf="!participantAdded">
        <button mat-icon-button matTooltip="No Participant Added" disabled=true>
          <mat-icon matTooltip="No Participant Added">supervisor_account</mat-icon>
        </button>
      </div>
      <div class="sepreator"></div>
      <div class="highlight" *ngIf="participantAdded">
        <button mat-button class="selectedParticipant" [matMenuTriggerFor]="menu">
          
          <span class="Cldeno" [ngStyle]="{'background-color': selectedParticipant?.colourCode}">
            <mat-icon *ngIf="selectedParticipant?.typeOfParticipant==0">email</mat-icon>
          <mat-icon *ngIf="selectedParticipant?.typeOfParticipant==4">person</mat-icon>
          <mat-icon *ngIf="selectedParticipant?.typeOfParticipant==5">work</mat-icon>
          <mat-icon *ngIf="selectedParticipant?.typeOfParticipant==1">app_registration</mat-icon>
          <mat-icon *ngIf="selectedParticipant?.typeOfParticipant==2">contact_mail</mat-icon>
          <mat-icon *ngIf="selectedParticipant?.typeOfParticipant==3">business</mat-icon>
          </span>
          <span class="roleDefine">{{selectedParticipant?.relationName}}</span>
           <ng-container *ngIf="selectedParticipant?.participantName=='Any One'">
            <p> {{selectedParticipant?.participantName}}</p>
           </ng-container>
            <ng-container *ngIf="selectedParticipant?.participantName!='Any One'">
              <p>{{ selectedParticipant?.participantName }}</p>
              <span *ngIf="selectedParticipant?.participantEmail">&nbsp; | &nbsp;</span>
              <p *ngIf="selectedParticipant?.participantEmail">{{ selectedParticipant?.participantEmail }}</p>
           </ng-container>          
          <!-- <p> {{selectedParticipant?.contactEmail}}</p> -->
          <mat-icon>expand_more</mat-icon>
        </button>

        <mat-menu #menu="matMenu">
          <ng-container *ngFor="let item of projectParticipantsList">
            <button mat-menu-item (click)="onclickMenu(item.colourCode, item,true)">
             
              <span class="Cldeno" [ngStyle]="{'background-color': item?.colourCode}">
                <mat-icon *ngIf="item.typeOfParticipant==0">email</mat-icon>
                <mat-icon *ngIf="item.typeOfParticipant==4">person</mat-icon>
                <mat-icon *ngIf="item.typeOfParticipant==5">work</mat-icon>
                <mat-icon *ngIf="item.typeOfParticipant==1">app_registration</mat-icon>
                <mat-icon *ngIf="item.typeOfParticipant==2">contact_mail</mat-icon>
                <mat-icon *ngIf="item.typeOfParticipant==3">business</mat-icon>
              </span>
              <span class="roleDefine">{{item.relationName}} </span>
              <ng-container *ngIf="item.participantName!='Any One'">      
                <p *ngIf="item.participantName">
                {{ item.participantName }}<span *ngIf="item.participantEmail"> | {{ item.participantEmail }}</span>
                </p>       
               <!-- <p *ngIf="item.participantName"> {{item?.participantName}} | {{item?.participantEmail}}</p> -->
               <p *ngIf="!item.participantName"> {{item?.participantEmail}}</p>
               </ng-container>
               <ng-container *ngIf="item.participantName=='Any One'">
                <p> {{item?.participantName}}</p>
               </ng-container>
              <!-- <p *ngIf="item.contactID!=0 || item.coreID!=0"> {{item?.participantName}}</p>
              <p *ngIf="item.contactID==0 || item.coreID==0"> {{item?.contactEmail}}</p> -->
            </button>
          </ng-container>
        </mat-menu>

      </div>

      <div class="sepreator aligntool"></div>
      <!-- 
      <mat-form-field style="width:50px;">
        <mat-select  
        [(ngModel)]="typeSelected"
        (selectionChange)="callAlignment()"
        >
  
          <mat-option [value]="icon.value"  *ngFor="let icon of iconHoder" >
            <mat-icon>{{icon.iconName}}</mat-icon>
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <button mat-icon-button (click)="undoClickHandler()" matTooltip="Undo" [disabled]="changesForUndo.length == '0'">
        <mat-icon matTooltip="Undo">undo</mat-icon>
      </button>
      <button mat-icon-button (click)="redoClickHandler()" matTooltip="Redo" [disabled]="changesForRedo.length == '0'">
        <mat-icon matTooltip="Redo">redo</mat-icon>
      </button>

      <button class="aligntool" mat-icon-button matTooltip="Align Horizontal Left" (click)='alignHorizontalLeft()'>
        <mat-icon>align_horizontal_left</mat-icon>
      </button>
      <button class="aligntool" mat-icon-button matTooltip="Align Horizontal Center" (click)="alignHorizontalCenter()">
        <mat-icon>align_horizontal_center</mat-icon>
      </button>
      <button class="aligntool" mat-icon-button matTooltip="Align Horizontal Right" (click)='alignHorizontalRight()'>
        <mat-icon>align_horizontal_right</mat-icon>
      </button>

      <div class="sepreator aligntool"></div>
      <button class="aligntool" mat-icon-button matTooltip="Align Vertical Bottom" (click)="alignVerticalBottom()">
        <mat-icon>align_vertical_bottom</mat-icon>
      </button>
      <button class="aligntool" mat-icon-button matTooltip="Align Vertical Center" (click)="alignVerticalCenter()">
        <mat-icon>align_vertical_center</mat-icon>
      </button>

      <button class="aligntool" mat-icon-button matTooltip="Align Vertical Top" (click)="alignVerticalTop()">
        <mat-icon>align_vertical_top</mat-icon>
      </button>
      <!-- <button class="aligntool" mat-icon-button matTooltip="Add Blank Page"(click)="alignVerticalTop()">
      <mat-icon  (click)="AddBlankPage()">
        note_add</mat-icon>
      </button> -->

     

      <div class="rOptPanel">
        <div class="sepreator"></div>
        <button mat-icon-button (click)="openRightPanel()">
          <mat-icon>library_books</mat-icon>
        </button>
        <ng-container *ngIf="controlAlignArray?.length>0">
          <div class="sepreator"></div>
          <button mat-icon-button (click)="opentoolDetailDevice()">
            <mat-icon>filter_alt</mat-icon>
          </button>
        </ng-container>
      </div>


    </mat-card>

    <div class="documentHolder example-boundary">
      <button mat-fab color="primary" class="toolsBtn" (click)="showTools()" cdkDragBoundary=".example-boundary"
        cdkDrag>
        <mat-icon *ngIf="showToolsLeft">close </mat-icon>
        <mat-icon *ngIf="!showToolsLeft">construction</mat-icon>
      </button>

      <form autocomplete="off">
        <div class="docSign" id="docSign" #content>
          <section class="FormResizer" (resized)="onResized($event)">
            <div class="docHolding dndDropArea" dndDropzone (dndDrop)="onDrop($event,data)" id="docHolding{{i+1}}"
              *ngFor="let data of imagesWithFields;let i= index;">
              <div class="iframe-drag-bounds" #dragBounds>
                <ng-container *ngIf='data.fields.length>0'>
                  <ng-container *ngFor="let item of data.fields;let i= index;">
                    <ng-container *ngIf="item.fieldTypeName!=='Checkbox' && item.fieldTypeName!=='Radio'
               && item.fieldTypeName!=='CheckBoxGroup' && item.fieldTypeName!=='Image'
               && item.fieldTypeName!=='Signature' && item.fieldTypeName!=='Initials'">

                      <div class="iframe-resize-container" 
                        id="Outer_{{item.id}}"
                        [ngClass]="{'fileControl' :item.fieldTypeName=='Draw'}"
                        [position]="{x: item.offsetX, y:item.offsetY}" ngResizable
                        [ngStyle]="{'position': 'absolute','margin-left': item.fieldTypeName=='Zip'?'12px':'', 'width': item.fieldTypeName=='AITextBox'? '100%': item.offsetWidth+'px','height': item.offsetHeight+'px'}"
                        rzHandles="n,s,e,w,se,sw" ngDraggable [handle]="dragHandle" [bounds]="dragBounds"
                        (stopped)="onStop($event)" (movingOffset)="onMoving($event,item,data,'')"
                        (endOffset)="onMoveEnd($event,data,item,'')" (keydown)="onImageKeyPress($event)"
                        [attr.tabIndex]="0" (rzStop)="onResizeStop($event,data,item.id)" [inBounds]="true"
                        [ngClass]="{'ng-show-required' : item.showRequiredControls}"
                        [ngStyle]="{'position': 'absolute','margin-left': item.fieldTypeName=='Zip'?'12px':'','width': item.fieldTypeName === 'State' ? '46px' :  item.offsetWidth + 'px','height': item.offsetHeight + 'px'}"                        
                        >
                        <div class="iframe-drag-handle" (click)="addActiveClass(item,data,$event)"
                          [ngStyle]="{'background-color': 'rgba(' + item.colorCodeAlpha + ')', 'border-color': 'rgba(' + item.colorCode + ')','transform':'rotate('+item.rotation+'deg)'}"
                          [ngClass]="{'ng-active' : item.ShowtoolDetail, 'state-control': item.fieldTypeName == 'State'}" #dragHandle>
                         
                         
                         
                         
                         
                         
                         
                         
                         
                          <ng-container *ngIf="item.fieldTypeName=='AITextBox'">

                            <ckeditor [config]="editorConfig" #editor (click)="LoadSelectedAIDocs(item.id)"
                              (click)="OpentoolDetail('AITextBox')" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" [ngModel]="item.selectedValue"
                              editorUrl="https://cdn.ckeditor.com/4.14.0/full/ckeditor.js" [name]="item.id"
                              [config]="ckEditorConfig" debounce="500" (ready)="onCkEditorReady($event)"
                              (ngModelChange)="onChangeCkeditor($event,data,item)"
                              (change)="adjustEditorHeight($event,item.id,data)" (paste)="onPaste($event)"
                              [id]="item.id">
                            </ckeditor>
                            <!-- (change)="onChangeCkeditor($event,data,item)" -->
                          </ng-container>
                          <ng-container *ngIf="item.fieldTypeName=='Textbox'">
                            <input type="text"
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="item.isEditable==false"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              [attr.maxlength]="item.charLimit" (input)="onChange($event.target.value,data,item)"
                              type="text" [value]="item.selectedValue" [attr.value]='item.selectedValue'
                              id="{{item.id}}" placeholder="{{item.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (blur)="AddBlurStyles(item)" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)"
                              (input)="onSetWidth(item)"
                              >

                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" (blur)="AddBlurStyles(item)"
                              *ngIf="item.isEditable==true"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              [attr.maxlength]="item.charLimit" (input)="onChange($event.target.value,data,item)"
                              type="text" [value]="item.selectedValue" [attr.value]='item.selectedValue'
                              id="{{item.id}}" [placeholder]="item.isShowAllEditablePlaceHolders? item.fieldName : '' "
                              (click)="OpentoolDetail('Textbox')" (blur)="AddBlurStyles(item)"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">

                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Textarea'">
                            <textarea
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="item.isEditable==true"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily
                ,'width': item.offsetWidth+'px','height': item.offsetHeight+'px'}" [attr.maxlength]="item.charLimit"
                              [value]="item.selectedValue" [innerHTML]='item.selectedValue'
                              (input)="onChange($event.target.value,data,item)" (click)="OpentoolDetail('Textarea')"
                              class="form-control" id="{{item.id}}" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" (blur)="AddBlurStyles(item)"></textarea>
                            <textarea *ngIf="item.isEditable==false" [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily
                  ,'width': item.offsetWidth+'px','height': item.offsetHeight+'px'}" [attr.maxlength]="item.charLimit"
                              [value]="item.selectedValue" [innerHTML]='item.selectedValue'
                              (input)="onChange($event.target.value,data,item)" (click)="OpentoolDetail('Textarea')"
                              class="form-control" id="{{item.id}}" placeholder="{{item.fieldName}}"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" (blur)="AddBlurStyles(item)"></textarea>

                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Currency'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="item.isEditable==false"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              [attr.maxlength]="item.charLimit" (input)="onChange($event.target.value,data,item)"
                              type="text" [value]="item.selectedValue" [attr.value]='item.selectedValue'
                              id="{{item.id}}" placeholder="{{item.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" (blur)="AddBlurStyles(item)">

                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="item.isEditable==true"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              [attr.maxlength]="item.charLimit" (input)="onChange($event.target.value,data,item)"
                              type="text" [value]="item.selectedValue" [attr.value]='item.selectedValue'
                              id="{{item.id}}" [placeholder]="item.isShowAllEditablePlaceHolders? item.fieldName : '' "
                              (click)="OpentoolDetail('Textbox')" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" (blur)="AddBlurStyles(item)">

                          </ng-container>

                          <ng-container
                            matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                            matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="item.fieldTypeName=='URL'">
                            <input
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize , 'font-family': item.fontfamily}"
                              type="text" [value]="item.selectedValue" [attr.value]='item.selectedValue'
                              (input)="onChange($event.target.value,data,item.id)" (click)="OpentoolDetail('URL')"
                              (click)="OpentoolDetailText(data,item.id,$event)" (blur)="AddBlurStyles(item)"
                              class="form-control" id="{{item.id}}" placeholder="{{item.placeholder}}"
                              (click)="putControlForReplcae(data,item)">
                          </ng-container>
                          <!-- <ng-container *ngIf="item.fieldTypeName=='MultiSelect'">
               {{item.selectedValue}}
              </ng-container>  -->
                          <ng-container *ngIf="item.fieldTypeName=='MultiSelect'">
                            <input readonly
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" *ngIf="item.isEditable==false"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              [attr.maxlength]="item.charLimit"
                              (click)="openMultiPopup(item,NewMultiSelectPopup,data.img)" type="text"
                              [value]="item.selectedValue" [attr.value]='item.selectedValue' id="{{item.id}}"
                              placeholder="{{item.fieldName}}" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">

                            <!-- <mat-select matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                 matTooltipShowDelay="2500"
                 matTooltipClass="tooltip"
                 (click)="putControlForReplcae(data,item)" 
                 id="{{item.id}}"
                 [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                 color="primary"
                
                 (selectionChange)="setDdlValue($event,data,item)"
                 (click)="OpentoolDetail('MultiSelect')"
                 (click)="OpentoolDetailMulDropDown(data,item.id,$event)" 
                 placeholder={{item.selectedValue}}               
                  [required]='item.isRequired'   multiple>
                 <mat-option *ngFor="let muldrp of item.fillList" [value]="muldrp.val">
                   {{ muldrp.val }}
                 </mat-option>
               </mat-select> -->
                          </ng-container>
                          <!-- <ng-container *ngIf="item.fieldTypeName=='MultiSelect'">
                <mat-select matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                matTooltipShowDelay="2500"
                matTooltipClass="tooltip"
                (click)="putControlForReplcae(data,item)" 
                id="{{item.id}}"
                [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                color="primary"
               
                (selectionChange)="setDdlValue($event,data,item)"
                (click)="OpentoolDetail('MultiSelect')"
                (click)="OpentoolDetailMulDropDown(data,item.id,$event)" 
                placeholder={{item.selectedValue}}               
                 [required]='item.isRequired' multiple>
                <mat-option *ngFor="let muldrp of filllist3" [value]="muldrp">
                  {{ muldrp }}
                </mat-option>
              </mat-select>                 
              </ng-container> -->

                          <ng-container *ngIf="item.fieldTypeName=='Address'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              (click)="putControlForReplcae(data,item)"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize , 'font-family': item.fontfamily}"
                              type="text" class="form-control" id="{{item.id}}" placeholder="{{item.fieldName}}"
                              [value]="item.selectedValue" [attr.value]='item.selectedValue'>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='City'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" type="text" matInput
                              placeholder="{{item.placeholder}}" aria-label="Number" id="{{item.id}}"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize , 'font-family': item.fontfamily}"
                              (input)="searchCity($event.target.value,data,item.id)" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" [value]="item.selectedValue"
                              [attr.value]='item.selectedValue' [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="cityselected($event,data,item.id)">
                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </ng-container>

                          <!-- <ng-container *ngIf="item.fieldTypeName=='State'">
                <mat-select matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}" matTooltipShowDelay="2500" matTooltipClass="tooltip" placeholder="{{item.placeholder}}"
                id="{{item.id}}" style="padding: 5px;" [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                   (click)="putControlForReplcae(data,item)"
                   (click)="OpentoolDetailDropDown(data,item.id,$event)"
                   (click)="OpentoolDetail('Dropdown')" 
                   (selectionChange)="setDdlValue($event,data,item.id)" 
                   [attr.value]="item.selectedValue">
                  <mat-option>None</mat-option>
                  <mat-option *ngFor="let state of stateList" [value]="state">{{state}}</mat-option>
                </mat-select>
               </ng-container> -->


                          <ng-container *ngIf="item.fieldTypeName === 'State'">
                          <select
                            class="stateControl"
                            matTooltip="{{ item.folderName !== '' && item.folderName !== undefined ? item.folderName : null }}"
                            matTooltipShowDelay="2500"
                            matTooltipClass="tooltip"
                            id="{{ item.id }}-{{ item.folderID }}"
                            style="padding: 5px;"
                            [ngClass]="[
                              item.selectedValue === '' || item.selectedValue === 'State' ? 'select-placeholder' : 'select-normal',
                              item.ShowtoolDetail ? 'ng-active' : ''
                            ]"
                            [value]="item.selectedValue || ''"
                            [(ngModel)]="item.selectedValue"
                            (mousedown)="onSelectMouseDown($event, data, item)"
                            (selectionChange)="setDdlValue($event, data, item)"
                            (change)="onSelectChange($event, item)"
                          >
                            <!-- Placeholder -->
                            <option value="" selected>State</option>

                            <!-- Dynamic State Options -->
                            <option
                              *ngFor="let state of stateList"
                              [value]="state"
                              [ngStyle]="{
                                'text-align': item.textalign,
                                'font-weight': item.fontstyle,
                                'font-style': item.fontweight,
                                'text-decoration': item.textdecoration,
                                'font-size': item.fontSize,
                                'font-family': item.fontfamily,
                                'height': item.offsetHeight + 'px'
                              }"
                            >
                              {{ state }}
                            </option>
                          </select>
                        </ng-container>



                          <ng-container *ngIf="item.fieldTypeName=='Zip'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" matInput type="text"
                              placeholder="{{item.placeholder}}" aria-label="Number"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize , 'font-family': item.fontfamily}"
                              (input)="searchZip($event.target.value,data,item.id)" (click)="OpentoolDetail('Textbox')"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)" [value]="item.selectedValue"
                              [attr.value]='item.selectedValue' [matAutocomplete]="ZipCode">
                            <mat-autocomplete #ZipCode="matAutocomplete"
                              (optionSelected)="zipselected($event,data,item.id)">
                              <mat-option
                                [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                                *ngFor="let option of zipOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Number'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              (click)="putControlForReplcae(data,item)" *ngIf="item.isEditable==true" [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily
                 ,'width': item.offsetWidth+'px','height': item.offsetHeight+'px'}" [value]="item.selectedValue"
                              [attr.value]='item.selectedValue' (input)="onChange($event.target.value,data,item)"
                              (click)="OpentoolDetail('Number')" type="text" class="form-control" id="{{item.id}}"
                              (keypress)="numberOnly($event)" id="{{item.id}}"
                              (click)="OpentoolDetailText(data,item.id,$event)">
                            <input (click)="putControlForReplcae(data,item)" *ngIf="item.isEditable==false" [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily
                 ,'width': item.offsetWidth+'px','height': item.offsetHeight+'px'}" placeholder="{{item.fieldName}}"
                              [value]="item.selectedValue" [attr.value]='item.selectedValue'
                              (input)="onChange($event.target.value,data,item)" (click)="OpentoolDetail('Number')"
                              type="text" class="form-control" id="{{item.id}}" (keypress)="numberOnly($event)"
                              id="{{item.id}}" (click)="OpentoolDetailText(data,item.id,$event)">
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Location'">

                            <div
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              (click)="putControlForReplcae(data,item)" id="{{item.id}}" class="customUpdate"
                              (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Location')"
                              (click)="fetchLocation(data,item.id)">
                              <span *ngIf='!item.Lat && !item.Long'>
                                <mat-icon>location_on</mat-icon>
                                Location
                              </span>
                              <ng-container *ngIf='item.Lat && item.Long'>
                                <h3
                                  [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize , 'font-family': item.fontfamily}">
                                  Lat : {{item.Lat}}
                                  Long: {{item.Long}}
                                </h3>
                              </ng-container>

                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Date' ">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              (click)="putControlForReplcae(data,item)" id="{{item.id}}" matInput
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize , 'font-family': item.fontfamily}"
                              [attr.Value]="item.selectedValue|date:'MM/dd/yyyy'" placeholder={{item.fieldName}}
                              readonly (input)="onChange($event.target.value,data,item)"
                              (dateChange)="onChange($event.target.value,data,item)" (click)="OpentoolDetail('Date')"
                              (click)="OpentoolDetailText(data,item.id,$event)" [matDatepicker]="basicDatepicker" />
                            <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                            <mat-datepicker #basicDatepicker></mat-datepicker>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Time'">
                            <!-- [ngxTimepicker]="toggleTimepicker" -->
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              (click)="putControlForReplcae(data,item)" id="{{item.id}}"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              aria-label="default time" (click)="OpentoolDetail('Time')"
                              (click)="OpentoolDetailText(data,item.id,$event)" matInput placeholder={{item.fieldName}}
                              [value]="item.selectedValue" [attr.Value]='item.selectedValue' readonly>
                            <ngx-material-timepicker-toggle matSuffix
                              [for]="toggleTimepicker"></ngx-material-timepicker-toggle>
                            <ngx-material-timepicker (timeSet)="onChange($event,data,item)" #toggleTimepicker>
                            </ngx-material-timepicker>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Dropdown'">
                            <!-- <mat-form-field > -->
                            <!-- <mat-label>Select</mat-label> -->
                            <mat-select
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" id="{{item.id}}"
                              style="padding: 5px;"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailDropDown(data,item.id,$event)" (click)="OpentoolDetail('Dropdown')"
                              placeholder="{{item.selectedValue!=undefined && item.selectedValue!=null && item.selectedValue!=''?item.selectedValue:item.fieldName}}"
                              (selectionChange)="setDdlValue($event,data,item)" [(value)]="item.selectedValue">
                             <!-- [attr.value]="item.selectedValue" -->
                              <mat-option
                                [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                                *ngFor="let drp of item.fillList" [value]="drp.val">
                                {{ drp.val }}
                              </mat-option>
                            </mat-select>
                            <!-- </mat-form-field> -->
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='File'">
                            <div
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" class="customUpdate"
                              (click)="OpentoolDetail('File')" id="{{item.id}}"
                              (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailText(data,item.id,$event)">
                              <span *ngIf='item.FileData.length==0'>
                                <mat-icon>cloud_upload</mat-icon>
                                Upload File1
                              </span>

                              <div *ngFor="let file of item.FileData" class="uploadedData">
                                <p>{{file.FullPath}}</p>

                              </div>
                              <input type="file" (change)="onSelectFile($event,data,item.id)" class="form-control"
                                id="{{item.fieldName}}" placeholder="{{item.fieldName}}">
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Draw'">
                            <div
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" id="{{item.id}}" class="customUpdate"
                              (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Draw')"
                              (click)="OpenDrawPopup(Draw,data,item,item.id)">
                              <!-- (click)="OpenDrawPopup(Draw,data,item.id)" -->
                              <span *ngIf='!item.drawBase64  && item.ImageData.length==0'>
                                <mat-icon>brush</mat-icon>
                                Draw
                              </span>
                              <img *ngIf='item.drawBase64' [src]="item.drawBase64" />
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Drawpopup'">
                            <div
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" id="{{item.id}}" class="customUpdate"
                              (click)="putControlForReplcae(data,item)" (click)="OpentoolDetail('Draw1')"
                              (click)="OpenDrawInPopup(DrawInPopup,data,item.id)">
                              <span *ngIf='!item.drawBase64  && item.ImageData.length==0'>
                                <mat-icon>brush</mat-icon>
                                Draw
                              </span>
                              <img *ngIf='item.drawBase64' [src]="item.drawBase64" />
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='BulletList'">
                            <label
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              (click)="putControlForReplcae(data,item)" id="{{item.id}}" class="bullet"
                              (click)="OpentoolDetail('BulletList')"
                              (click)="OpentoolDetailBulletList(data,item.id,$event)">
                              <ul (click)="putControlForReplcae(data,item)"
                                (click)="OpentoolDetailBulletList(data,item.id,$event)">
                                <li (click)="putControlForReplcae(data,item)"
                                  [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                                  *ngFor="let bu of item.fillList">{{bu.val}}</li>
                              </ul>
                            </label>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Button'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              type="submit" [value]='item.buttonName' class="btnGlobal" id="{{item.id}}"
                              (click)="OpentoolDetail('Button')" (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailText(data,item.id,$event)">
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='ApproveOrDecline'">
                            <input
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip"
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              *ngIf="item.buttonText=='Approve'" type="submit" [value]="item.buttonText"
                              class="btn-success btnAccept" id="{{item.id}}"
                              (click)="OpentoolDetail('ApproveOrDecline')"
                              (click)="OpentoolDetailText(data,item.id,$event)">
                            <input
                              [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                              *ngIf="item.buttonText=='Decline'" type="submit" [value]="item.buttonText"
                              class="btn-success btnDecline" id="{{item.id}}"
                              (click)="OpentoolDetail('ApproveOrDecline')" (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailText(data,item.id,$event)">
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='Table'">
                            <table
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" id="{{item.id}}" class="formTable"
                              border="1px" (click)="OpentoolDetail('Table')" (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailText(data,item.id,$event)">
                              <tbody (click)="OpentoolDetailtbl(data,item.id,$event)">
                                <tr *ngFor="let row of item.rows;let r=index">
                                  <td *ngFor="let column of item.column;let c=index">
                                    <input id='txt-{{r+1}}{{c+1}}' [attr.value]="getColumnValue(data,item.id,r+1,c+1)"
                                      (input)="onTableChange($event,data,item.id)" type="text" />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='StrikeThrough'">
                            <div id="{{item.id}}"
                              style="border-top: 1px solid black; width: 100%;height: 20px; margin-top:18px"
                              (click)="OpentoolDetail('StrikeThrough')"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='WhiteOut'">
                            <div id="{{item.id}}" style="background-color: white; width: 100%;height: 100%;"
                              (click)="OpentoolDetail('WhiteOut')" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='HighLight'">
                            <div style=" width: 100%;height: 100%;" id="{{item.id}}"
                              [ngStyle]="{'background-color': 'rgba(' + item.backgroundColor + ')'}"
                              (click)="OpentoolDetail('HighLight')" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='StraightLine'">
                            <div id="{{item.id}}"
                              style="border-bottom: 1px solid black; width: 100%;height: 20px; margin-top:0px"
                              (click)="OpentoolDetail('line')" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">
                            </div>
                          </ng-container>

                          <ng-container *ngIf="item.fieldTypeName=='measure'">
                            <div id="{{item.id}}" style="border-bottom: 1px solid black; width: 100%; margin:0px"
                              (click)="OpentoolDetail('measure')" (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="putControlForReplcae(data,item)">
                              {{item?.width}}
                            </div>
                          </ng-container>

                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.fieldTypeName=='Signature'">
                      <div class="iframe-resize-container"
                        [ngClass]="{'fileControl' :item.fieldTypeName=='Signature' || item.fieldTypeName=='Initials'}"
                        [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                        [position]="{x: item.offsetX, y:item.offsetY}" ngResizable [rzAspectRatio]="true"
                        [rzMinWidth]="81" [rzMinHeight]="27"
                        [ngStyle]="{'position': 'absolute','width': item.offsetWidth+'px','height': item.offsetHeight+'px'}"
                        rzHandles="n,s,e,w,se,sw" ngDraggable [handle]="dragHandle" [bounds]="dragBounds"
                        (stopped)="onStop($event)" (movingOffset)="onMoving($event,item,data,'')"
                        (endOffset)="onMoveEnd($event,data,item,'')" (keydown)="onImageKeyPress($event)"
                        [attr.tabIndex]="0" (rzStop)="onResizeStop($event,data,item.id)" [inBounds]="true"
                        [ngClass]="{'ng-show-required' : item.showRequiredControls}">

                        <div class="iframe-drag-handle" (click)="addActiveClass(item,data,$event)"
                          [ngStyle]="{'background-color': 'rgba(' + item.colorCodeAlpha + ')', 'border-color': 'rgba(' + item.colorCode + ')','transform':'rotate('+item.rotation+'deg)'}"
                          [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                          [ngClass]="{'bnone' : item.signatureBase64!='' || item.signatureText!='' && item.signatureBase64=='' || item.ImageData.length>0}"
                          #dragHandle>

                          <ng-container *ngIf="item.fieldTypeName=='Signature'">
                            <div
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" id="{{item.id}}" class="customUpdate"
                              [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                              (click)="putControlForReplcae(data,item)"
                              (click)="OpentoolDetailText(data,item.id,$event)" (click)="OpentoolDetail('Signature')"
                              (click)="OpenSignPopupNew(data,item,$event)"
                              >
                              <!-- (click)="OpenSignPopup(AddSignature,data,item)" -->
                              <!-- (click)="OpenSignPopup(AddSignature,data,item,$event)" -->
                              <span *ngIf='!item.signatureBase64 && !item.signatureText && item.ImageData.length==0'>
                                <mat-icon>border_color</mat-icon>
                                Signature
                              </span>

                              <!-- Signature Stamp-->
                              <div class="sig-cell"
                                *ngIf='item.signatureBase64 || item.signatureText && !item.signatureBase64 || item.ImageData.length>0'
                                [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                <div class="sig-chrome"
                                  [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics
                                  </div>
                                  <div class="sig-container"
                                    [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                    <img *ngIf='item.signatureBase64' [src]="item.signatureBase64" />
                                    <ng-container *ngIf='item.signatureText && !item.signatureBase64'>
                                      <h3 [ngStyle]="{'font-family': item.signInitialFontFamily}">{{item.signatureText}}
                                      </h3>
                                    </ng-container>

                                    <div *ngFor="let img of item.ImageData" class="uploadedData"
                                      [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                      <img [src]="img.Imageurl" />
                                    </div>

                                  </div>
                                  <div class="sig-chrome-title-bottom ng-binding">{{item.participantEmailId}}</div>
                                </div>
                              </div>
                              <!-- Signature Stamp-->
                              <!-- <img *ngIf='item.signatureBase64' [src]="item.signatureBase64" /> 
                   <ng-container  *ngIf='item.signatureText && !item.signatureBase64' >
                     <h3 [ngStyle]="{'font-family': item.signInitialFontFamily}" >{{item.signatureText}}</h3>
                   </ng-container>
                   <div *ngFor="let img of item.ImageData" class="uploadedData">
                     <img [src]="img.Imageurl"/> 
                  </div>                 -->
                            </div>
                          </ng-container>



                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.fieldTypeName=='Initials'">
                      <div class="iframe-resize-container"
                        [ngClass]="{'fileControl' :item.fieldTypeName=='Signature' || item.fieldTypeName=='Initials'}"
                        [position]="{x: item.offsetX, y:item.offsetY}" ngResizable [rzAspectRatio]="true"
                        [rzMinWidth]="27" [rzMinHeight]="27"
                        [ngStyle]="{'position': 'absolute','width': item.offsetWidth+'px','height': item.offsetHeight+'px'}"
                        rzHandles="n,s,e,w,se,sw" ngDraggable [handle]="dragHandle" [bounds]="dragBounds"
                        [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                        (stopped)="onStop($event)" (movingOffset)="onMoving($event,item,data,'')"
                        (endOffset)="onMoveEnd($event,data,item,'')" (keydown)="onImageKeyPress($event)"
                        [attr.tabIndex]="0" (rzStop)="onResizeStop($event,data,item.id)" [inBounds]="true"
                        [ngClass]="{'ng-show-required' : item.showRequiredControls}">

                        <div class="iframe-drag-handle" (click)="addActiveClass(item,data,$event)"
                          [ngStyle]="{'background-color': 'rgba(' + item.colorCodeAlpha + ')', 'border-color': 'rgba(' + item.colorCode + ')','transform':'rotate('+item.rotation+'deg)'}"
                          [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                          [ngClass]="{'bnone' : item.signatureBase64!='' || item.signatureText!='' && item.signatureBase64=='' || item.ImageData.length>0}"
                          #dragHandle>


                          <ng-container *ngIf="item.fieldTypeName=='Initials'">
                            <div
                              matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                              matTooltipShowDelay="2500" matTooltipClass="tooltip" id="{{item.id}}" class="customUpdate"
                              [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                              (click)="putControlForReplcae(data,item)" (click)="OpentoolDetail('Initials')"
                              (click)="OpentoolDetailText(data,item.id,$event)"
                              (click)="OpenSignPopup(AddInitial,data,item.id,$event)">
                              <!-- (click)="OpenSignPopup(AddInitial,data,item.id)" -->
                              <span *ngIf='!item.signatureBase64 && !item.signatureText && item.ImageData.length==0'>
                                <mat-icon>gesture</mat-icon>
                                Initials
                              </span>
                              <!-- Signature Stamp-->
                              <div class="sig-cell"
                                *ngIf='item.signatureBase64 || item.signatureText && !item.signatureBase64 || item.ImageData.length>0'
                                [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                <div class="sig-chrome"
                                  [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                  <div class="sig-chrome-title-top ng-scope" translate="flowtrics by:">By flowtrics
                                  </div>
                                  <div class="sig-container"
                                    [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                    <img *ngIf='item.signatureBase64' [src]="item.signatureBase64" />
                                    <ng-container *ngIf='item.signatureText && !item.signatureBase64'>
                                      <h3 [ngStyle]="{'font-family': item.signInitialFontFamily}">{{item.signatureText}}
                                      </h3>
                                    </ng-container>

                                    <div *ngFor="let img of item.ImageData" class="uploadedData"
                                      [ngStyle]="{'height': item.offsetHeight +'px', 'width': item.offsetWidth +'px'}">
                                      <img [src]="img.Imageurl" />
                                    </div>

                                  </div>
                                  <div class="sig-chrome-title-bottom ng-binding">{{item.participantEmailId}}</div>
                                </div>
                              </div>
                              <!-- Signature Stamp-->
                              <!-- <img *ngIf='item.signatureBase64' [src]="item.signatureBase64" /> 
                     <ng-container  *ngIf='item.signatureText && !item.signatureBase64' >
                       <h3 [ngStyle]="{'font-family': item.signInitialFontFamily}" >{{item.signatureText}}</h3>
                     </ng-container>
                     <div *ngFor="let img of item.ImageData" class="uploadedData">
                       <img [src]="img.Imageurl"/> 
                    </div>-->
                            </div>
                          </ng-container>

                        </div>
                      </div>
                    </ng-container>

                    <ng-container *ngIf="item.fieldTypeName=='Checkbox' || item.fieldTypeName=='Radio' ||
          item.fieldTypeName=='CheckBoxGroup'">
                      <div class="radioHolder" id="{{item.id}}">
                        <div *ngFor="let ele of item.fillList; let i=index" class="iframe-resize-container"
                          [position]="{x: ele.offsetX, y:ele.offsetY}" style="position: absolute;" ngResizable
                          (stopped)="onStop($event)" (movingOffset)="onMoving($event,item,data,ele)"
                          (endOffset)="onMoveEnd($event,data,item,ele)" (keydown)="onImageKeyPress($event)"
                          [attr.tabIndex]="0" (rzStop)="onResizeStop($event,data,item.id)" rzHandles="n,s,e,w,se,sw"
                          ngDraggable [handle]="dragHandle" [bounds]="dragBounds" [inBounds]="true"
                          [ngClass]="{'ng-show-required' : item.showRequiredControls}">
                          <div class="iframe-drag-handle" (click)="addActiveClass(item,data,$event)"
                            [ngClass]="{'ng-active' : item.ShowtoolDetail}"
                            [ngStyle]="{'background-color': 'rgba(' + item.colorCodeAlpha + ')', 'border-color': 'rgba(' + item.colorCode + ')','width': item.offsetWidth+'px','height': item.offsetHeight+'px'}"
                            #dragHandle>

                            <ng-container *ngIf="item.fieldTypeName=='Checkbox'">
                              <label
                                [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                                class="checkboxItem" (click)="OpentoolDetail('Checkbox')"
                                (click)="putControlForReplcae(data,item)"
                                (click)="OpentoolDetailCheckBox(data,item.id,ele.id,$event)">
                                <!-- <ng-container> -->
                                <!-- <mat-checkbox  color="primary" [checked]='ifChkChecked(item.id,data,ele.id)'
                      (change)="OnChangeCheckBox($event, ele.val, item.id,data,ele.id)">
                       <span [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                       >{{ele.val}}</span>
                     </mat-checkbox> -->
                                <input
                                  matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                                  matTooltipShowDelay="2500" matTooltipClass="tooltip" type="checkbox"
                                  [id]='item.id+ele.id' [checked]='ifChkChecked(item.id,data,ele.id)'
                                  [attr.checked]="ifChkChecked(item.id,data,ele.id)? 'checked' : null"
                                  (click)="OnChangeCheckBox($event, ele.val, item,data,ele.id)">
                                <label *ngIf="item.isShowChkLabel==true"> {{ele.val}} </label>
                                <!-- </ng-container> -->
                              </label>
                            </ng-container>

                            <ng-container *ngIf="item.fieldTypeName=='Radio'">
                              <div class="flexCol" id="{{item.id}}">
                                <label
                                  [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                                  class="radioItem" (click)="OpentoolDetail('Radio')"
                                  (click)="putControlForReplcae(data,item)"
                                  (click)="OpentoolDetailRadioButtonGroup(data,item.id,ele.id,$event)">
                                  <!-- <mat-radio-button color="primary"  [checked]='ifRadioChecked(item.id,data,ele.id)' (change)="OnChangeRadio($event, ele.val, item.id,data,ele.id)"></mat-radio-button>-->
                                  <input
                                    matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                                    matTooltipShowDelay="2500" matTooltipClass="tooltip" type="radio" name='{{item.id}}'
                                    [checked]='ifRadioChecked(item.id,data,ele.id)'
                                    [attr.checked]="ifRadioChecked(item.id,data,ele.id)? 'checked' : null"
                                    (change)="OnChangeRadio($event, ele.val, item.id,data,ele.id)">
                                  {{ele.val}}
                                </label>
                                <span class="addChRad" *ngIf="item.fillList.length==(i+1)"><mat-icon
                                    (click)="AddControlRadioButon(item.id,data)">add</mat-icon></span>
                              </div>
                            </ng-container>

                            <ng-container *ngIf="item.fieldTypeName=='CheckBoxGroup'">
                              <div class="flexCol" id="{{item.id}}">
                                <label
                                  [ngStyle]="{'color': item.fontColor, 'text-align': item.textalign, 'font-weight': item.fontstyle, 'font-style': item.fontweight, 'text-decoration': item.textdecoration, 'font-size': item.fontSize, 'font-family': item.fontfamily}"
                                  class="checkboxItem" (click)="OpentoolDetail('CheckBoxGroup')"
                                  (click)="putControlForReplcae(data,item)"
                                  (click)="OpentoolDetailCheckBoxGroup(data,item.id,ele.id,$event)">
                                  <!-- <mat-checkbox  color="primary" [checked]='ifChkChecked(item.id,data,ele.id)' (change)="OnChangeCheckBoxGroup($event, ele.val, item.id,data,ele.id)">
                      <span>{{ele.val}}</span>
                    </mat-checkbox>-->
                                  <input
                                    matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                                    matTooltipShowDelay="2500" matTooltipClass="tooltip" type="checkbox"
                                    [id]='item.id+ele.id' [checked]='ifChkChecked(item.id,data,ele.id)'
                                    [attr.checked]="ifChkChecked(item.id,data,ele.id)? 'checked' : null"
                                    (change)="OnChangeCheckBoxGroup($event, ele.val, item,data,ele.id)">
                                  <label *ngIf="item.isShowChkLabel==true">{{ele.val}}</label>
                                </label>
                                <span class="addChRad" *ngIf="item.fillList.length==(i+1)"><mat-icon
                                    (click)="AddControlCheckBoxGroup(item.id,data)">add</mat-icon></span>
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </ng-container>


                    <ng-container *ngIf="item.fieldTypeName=='Image'">
                      <div class="radioHolder" id="{{item.id}}">
                        <div *ngFor="let ele of item.fillList; let i=index" class="iframe-resize-container"
                          [ngClass]="{'fileControl' :item.fieldTypeName=='Image'}"
                          [position]="{x: item.offsetX, y:item.offsetY}"
                          [ngStyle]="{'height': item.Imageheight, 'width': item.Imagewidth}" style="position: absolute;"
                          ngResizable (stopped)="onStop($event)" (movingOffset)="onMoving($event,item,data,'')"
                          (endOffset)="onMoveEnd($event,data,item,'')" (keydown)="onImageKeyPress($event)"
                          [attr.tabIndex]="0" (rzStop)="onResizeStop($event,data,item.id)" rzHandles="n,s,e,w,se,sw"
                          ngDraggable [handle]="dragHandle" [bounds]="dragBounds" [inBounds]="true"
                          [ngClass]="{'ng-show-required' : item.showRequiredControls}"
                          [ngClass]="{'ng-active' : item.ShowtoolDetail}">
                          <div class="iframe-drag-handle" (click)="addActiveClass(item,data,$event)"
                            [ngStyle]="{'background-color': 'rgba(' + item.colorCodeAlpha + ')', 'border-color': 'rgba(' + item.colorCode + ')'}"
                            #dragHandle>

                            <ng-container *ngIf="item.fieldTypeName=='Image'">
                              <div
                                matTooltip="{{item.folderName!=='' && item.folderName!==undefined?item.folderName:null }}"
                                matTooltipShowDelay="2500" matTooltipClass="tooltip" class="customUpdate"
                                (click)="OpentoolDetail('Image')" id="{{item.id}}"
                                (click)="OpentoolDetailText(data,item.id,$event)"
                                (click)="putControlForReplcae(data,item)">
                                <span *ngIf='item.ImageData.length==0'>
                                  <mat-icon>cloud_upload</mat-icon>
                                  Upload Image
                                </span>
                                <div *ngFor="let img of item.ImageData" class="uploadedData">
                                  <img *ngIf='img.Imageurl' [src]="img.Imageurl" />
                                </div>
                                <!-- (change)="onSelectImage($event,data,item.id)"-->
                                <input type="file" class="form-control" (change)="onSelectImage($event,data,item.id)"
                                  accept="image/*" id="{{item.fieldName}}" placeholder="{{item.fieldName}}">
                              </div>
                            </ng-container>

                          </div>
                        </div>
                      </div>
                    </ng-container>

                  </ng-container>
                </ng-container>
                <img [src]="data.img" id="imgSrc{{i}}" [ngStyle]="{ 'width':ImageWidth, 'height':ImageHeight}"
                  (click)="onClickOutside()" (click)="onClickonImage($event,data)" (keydown)="onImageKeyPress($event)"
                  [ngClass]="{'progress': waitPointer}" [attr.tabIndex]="0" />
              </div>
            </div>
          </section>
        </div>
      </form>
    </div>
  </div>

  <mat-card class="rblockPanel" [ngClass]="{'active' : openRight}">
    <div class="allpages">
      <mat-accordion>
        <ng-container *ngIf='projectDocuments.length>0'>
          <mat-expansion-panel [expanded]="indexExpanded == i" *ngFor='let p of projectDocuments ;let i = index'>
            <mat-expansion-panel-header (click)='FillDocImagesWithFields(p.projectDocumentID,true)'
              (click)='PostWaitInitFunctionality()'>
              <mat-panel-title>
                <div class="title">
                  <p matTooltipClass="tooltip" matTooltip="{{p.documentName}}">{{p.documentName}}</p>
                  <!-- <div *ngIf='p.pdFtoImageStatus==0'><mat-icon class="pending">pending</mat-icon></div>
              <div *ngIf='p.pdFtoImageStatus==1'><mat-icon class="inprogress">hourglass_empty</mat-icon></div>
              <div *ngIf='p.pdFtoImageStatus==2'><mat-icon class="error">error</mat-icon></div>
              <div *ngIf='p.pdFtoImageStatus==3'><mat-icon class="done">verified</mat-icon></div> -->

                  <div class="iconStatus">

                    <ng-container *ngIf='p.pdFtoImageStatus==0'>
                      <button color="primary" mat-icon-button matTooltipClass="tooltip"
                        matTooltip="Pending, Please refresh" (click)="refreshJson()">
                        <mat-icon>refresh</mat-icon>
                      </button>
                    </ng-container>
                    <ng-container *ngIf='p.pdFtoImageStatus==1'>
                      <button color="primary" mat-icon-button matTooltipClass="tooltip"
                        matTooltip="Inprogress, Please refresh" (click)="refreshJson()">
                        <mat-icon>downloading</mat-icon>
                      </button>
                    </ng-container>
                    <ng-container *ngIf='p.pdFtoImageStatus==2'>
                      <button color="warn" mat-icon-button matTooltipClass="tooltip" matTooltip="Error, Please retry"
                        (click)="retryPdfToImage(p)">
                        <mat-icon>sync_problem</mat-icon>
                      </button>
                    </ng-container>
                    <ng-container *ngIf='p.pdFtoImageStatus==3'>
                      <mat-icon class="doneConvert" matTooltipClass="tooltip" matTooltip="Done" (click)="refreshJson()">
                        published_with_changes</mat-icon>
                    </ng-container>



                  </div>

                </div>
              </mat-panel-title>

            </mat-expansion-panel-header>

            <div class="page" (click)='scrollToPage(i+1)' (click)="setPagesList(p.images)"
              *ngFor="let im of p.images;let i=index">
              <span>{{i+1}}</span>
              <img [src]="im.pageImageThumbnail" alt="" />

              <button (click)="AddBlankPage(im)" class="addPage" color="primary" mat-icon-button
                matTooltip="Add Blank Page">
                <mat-icon>note_add</mat-icon>
              </button>
            </div>
            <!-- <div class="page"></div>
        <div class="page"></div>
        <div class="page"></div>
        <div class="page"></div>
        <div class="page"></div>
        <div class="page"></div> -->
          </mat-expansion-panel>
        </ng-container>
      </mat-accordion>
    </div>
  </mat-card>
  <div class="roblockOverlay" (click)="openRightPanel()" [ngClass]="{'active' : openRight}"></div>

  <mat-card class="toolDetail" [ngClass]="{'open': ShowtoolDetail, 'openInDevice': openInDevice}">
    <div class="blockC selected" style="flex-direction: row; justify-content: space-between; align-items: center;">
      <div class="xrow" *ngIf="Ssingleline">
        <mat-icon>power_input</mat-icon>Single-Line
      </div>
      <div class="xrow" *ngIf="Smultiline">
        <mat-icon>dehaze</mat-icon>Multi-Line
      </div>
      <div class="xrow" *ngIf="Snumber">
        <mat-icon>filter_1</mat-icon>Number
      </div>
      <div class="xrow" *ngIf="Sradio">
        <mat-icon>radio_button_checked</mat-icon>Radio
      </div>
      <div class="xrow" *ngIf="Sdropdown">
        <mat-icon>arrow_drop_down_circle</mat-icon>Dropdown
      </div>
      <div class="xrow" *ngIf="Smuldropdown">
        <mat-icon>arrow_drop_down_circle</mat-icon>MultiSelect Dropdown
      </div>
      <div class="xrow" *ngIf="Scheckbox">
        <mat-icon>check_box</mat-icon>Check Box
      </div>
      <div class="xrow" *ngIf="Scheckboxgroup">
        <mat-icon>check_box</mat-icon>Check Box
      </div>
      <div class="xrow" *ngIf="Sbullet">
        <mat-icon>format_list_bulleted</mat-icon>Bullet List
      </div>
      <div class="xrow" *ngIf="Stable">
        <mat-icon>table_chart</mat-icon>Table
      </div>

      <div class="xrow" *ngIf="Sdraw">
        <mat-icon>brush</mat-icon>Draw
      </div>
      <div class="xrow" *ngIf="Smeasure">
        <mat-icon>straighten</mat-icon>Measure
      </div>
      <div class="xrow" *ngIf="Sline">
        <mat-icon>minimize</mat-icon>Straight line
      </div>
      <div class="xrow" *ngIf="Sthrough">
        <mat-icon>strikethrough_s</mat-icon>Strike through
      </div>
      <div class="xrow" *ngIf="SwhiteOut">
        <mat-icon>outbond</mat-icon>White Out
      </div>
      <div class="xrow" *ngIf="ShighLight">
        <mat-icon>highlight_alt</mat-icon>High Light
      </div>

      <div class="xrow" *ngIf="Ssignature">
        <mat-icon>create</mat-icon>Signature
      </div>
      <div class="xrow" *ngIf="Sinitials">
        <mat-icon>gesture</mat-icon>Initials
      </div>

      <div class="xrow" *ngIf="Sapproval">
        <mat-icon>done</mat-icon>{{acceptOrdeclineText}}
      </div>
      <div class="xrow" *ngIf="Sdate">
        <mat-icon>event_available</mat-icon>Date
      </div>
      <div class="xrow" *ngIf="Stime">
        <mat-icon>schedule</mat-icon>Time
      </div>
      <div class="xrow" *ngIf="Slocation">
        <mat-icon>location_on</mat-icon>Location
      </div>

      <div class="xrow" *ngIf="Sfile">
        <mat-icon>insert_drive_file</mat-icon>File
      </div>
      <div class="xrow" *ngIf="Simage">
        <mat-icon>wallpaper</mat-icon>Image
      </div>
      <div class="xrow" *ngIf="SbuttonLabel">
        <mat-icon>smart_button</mat-icon>Button
      </div>
      <div class="xrow" *ngIf="SURLL">
        <mat-icon>smart_button</mat-icon>URL
      </div>
      <div class="xrow" *ngIf="SAItext">
        <mat-icon>smart_button</mat-icon>AI Tool
      </div>

      <button mat-icon-button (click)="closeDetail()"><mat-icon>close</mat-icon></button>

    </div>

    <div class="allToolDetail">

      <div class="blockC Required">
        <div class="xrow mtb5">
          <div class="poscheck" *ngIf="!SAItext">
            <label>
              <!-- <input type="checkbox" [(ngModel)]="isRequired" (change)="checkBoxEvent($event)"/> Required -->
              <mat-checkbox color="primary" [(ngModel)]="isRequired" (change)="checkBoxRequiredEvent($event)">Required
              </mat-checkbox>
            </label>
          </div>

          <button  color="primary" mat-button (click)="ClearData()">Clear</button>
      

          <div class="poscheck" *ngIf="SreadOnly">
            <label>
              <mat-checkbox color="primary" [(ngModel)]="readonly" (change)="checkBoxReadOnlyEvent($event)">Read only
              </mat-checkbox>
              <!-- <input type="checkbox" value="" /> Read only -->
            </label>
          </div>
        </div>
      </div>


      <div class="blockC xyposition dropOptions" *ngIf="Sbullet">
        <div class="lab">Bullet</div>
        <div class="yrow mtb5">
          <div class="sblab">Add points</div>
          <div *ngFor="let row of bulletFieldArray; let i = index" class="opt">
            <mat-icon>fiber_manual_record</mat-icon>

            <mat-form-field class="example-full-width">
              <input matInput placeholder="Point {{i+1}}" [(ngModel)]="row.val"
                (input)="onChangebulletlist($event.target.value)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>
            <button mat-icon-button>
              <mat-icon (click)="deleteField('b',row)">close</mat-icon>
            </button>
          </div>

          <div class="opt">
            <button color="primary" (click)="addValueFielbullet()" mat-icon-button>
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>


      <div class="blockC xyposition dropOptions" *ngIf="Sdropdown">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
        <br *ngIf="selectedFolderID==0">
        <div class="lab">Options</div>
        <div class="yrow mtb5" [ngClass]="{'disableDiv': dropdownddisabled}">
          <div class="sblab">Add list of options</div>

          <div *ngFor="let row of dropdownFieldArray; let i = index" class="opt">
            <mat-icon>fiber_manual_record</mat-icon>
            <mat-form-field class="example-full-width">
              <input matInput placeholder="Option {{i+1}}" [(ngModel)]="row.val"
                (input)="onChangedropdownlist($event.target.value)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>
            <button mat-icon-button *ngIf="!dropdownddisabled">
              <mat-icon (click)="deleteField('d',row)">close</mat-icon>
            </button>
          </div>
          <div class="opt" *ngIf="!dropdownddisabled">
            <button color="primary" (click)="addValueFielDropDown()" mat-icon-button>
              <mat-icon>add</mat-icon>
            </button>
          </div>
        </div>
      </div>

      <div class="blockC xyposition dropOptions" *ngIf="Sradio">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
        <div class="lab">Radio buttons</div>
        <div class="yrow mtb5">
          <div class="sblab">Add list of values</div>

          <div *ngFor="let row of radioButtonGroupFieldArray; let i = index" class="opt">
            <mat-icon>radio_button_checked</mat-icon>
            <mat-form-field class="example-full-width">
              <mat-label> Option </mat-label>
              <input matInput placeholder="Option {{i+1}}" value="" [(ngModel)]="row.val"
                (input)="onChangeRadioButtonGrouplist($event.target.value,row)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>
            <button mat-icon-button>
              <mat-icon (click)="deleteField('r',row)">close</mat-icon>
            </button>
          </div>


        </div>
      </div>

      <div class="blockC xyposition dropOptions" *ngIf="Scheckbox">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
        <div class="lab">Checkbox buttons</div>
        <div class="yrow mtb5" [ngClass]="{'disableDiv': checkboxdisabled}">
          <div class="sblab">Add list of values</div>

          <div *ngFor="let row of checkboxFieldArray; let i = index" class="opt">
            <mat-icon>check_box_outline_blank</mat-icon>
            <mat-form-field class="example-full-width">
              <mat-label>Label</mat-label>
              <input matInput placeholder="Add Label" value="" [(ngModel)]="row.val"
                (input)="onChangecheckboxlist($event.target.value)" [ngModelOptions]="{standalone: true}" />

            </mat-form-field>
          </div>
          <label>
            <mat-checkbox color="primary" [(ngModel)]="isShowChkLabel" (change)="isShowChkLabelEvent($event)">Show Label
            </mat-checkbox>
          </label>
        </div>
      </div>

      <div class="blockC xyposition" *ngIf="Scheckboxgroup">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
        <div class="lab">Checkbox buttons</div>
        <div class="yrow mtb5" [ngClass]="{'disableDiv': checkboxdisabled}">
          <div class="sblab">Add list of values</div>

          <div *ngFor="let row of checkboxGroupFieldArray; let i = index" class="opt">
            <mat-icon>check_box_outline_blank</mat-icon>
            <mat-form-field class="example-full-width">
              <mat-label>Label</mat-label>
              <input matInput placeholder="Add Label" value="" [(ngModel)]="row.val"
                (input)="onChangecheckboxGrouplist($event.target.value,row)" [ngModelOptions]="{standalone: true}" />
            </mat-form-field>

            <button mat-icon-button>
              <mat-icon (click)="deleteField('c',row)">close</mat-icon>
            </button>
          </div>

          <label>
            <mat-checkbox color="primary" [(ngModel)]="isShowChkLabel" (change)="isShowChkLabelEvent($event)">Show Label
            </mat-checkbox>
          </label>

        </div>
      </div>

      <div class="blockC xyposition" *ngIf="Stable">
        <div class="lab">Table</div>
        <div class="xrow mtb5">
          <div class="pos">Rows <input type="text" id='txt-tbl-row' maxlength="2" [(ngModel)]="tblrowsnumber"
              (input)="onChangetblrows($event.target.value)" /></div>
          <div class="pos">Columns <input type="text" id='txt-tbl-column' maxlength="2" [(ngModel)]="tblclmnumber"
              (input)="onChangetblclm($event.target.value)" /></div>
        </div>
      </div>


      <div class="blockC" *ngIf="Sbutton">
        <div class="xrow mtb5">
          <div class="poscheck">
            <label><input type="radio" [checked]="acceptchecked" (click)='OnAcceptOrDecline($event,true)' name="button"
                value="" /> Approve</label>
          </div>
          <div class="poscheck">
            <label><input type="radio" [checked]="declinechecked" (click)='OnAcceptOrDecline($event,false)'
                name="button" value="" /> Decline</label>
          </div>
        </div>
      </div>

      <div class="blockC" *ngIf="Stext">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />

        </div>
        <br *ngIf="selectedFolderID==0">
        <div class="lab">Add Text</div>
        <div class="xrow txtarea">
          <textarea [(ngModel)]="text" [maxlength]="characterlimit"
            (input)="onChangeText($event.target.value)"></textarea>
        </div>
        <!-- <div class="lab">Calculation Expression</div>
      <div class="xrow txtarea">
        <textarea [(ngModel)]="expression"
          (input)="onChangeExpression($event.target.value)"></textarea>
      </div>
      <div class="lab">Control ID</div>
      <label>{{ControlId}}</label> -->
        <div class="xrow limit">
          <!-- <label class="nopadding clrlbl"> Characters Remaining: {{text.length}}/{{characterlimit}}</label> -->
          <input type="text" [(ngModel)]="characterlimit" (input)="onChangeCharLimit($event.target.value)" />
          <span>Set Character Limit</span>
        </div>
      </div>

      <div class="blockC" *ngIf="SButtontext">
        <div class="lab">Add Text</div>
        <div class="xrow txtarea">
          <textarea [(ngModel)]="buttonText" (input)="onChangeTextButton($event.target.value)"></textarea>
        </div>
      </div>


      <div class="blockC" *ngIf="SURL">
        <div class="lab">Add URL</div>
        <div class="xrow txtarea">
          <input matInput type="url" name="url" id="url" placeholder="https://example.com" pattern="https://.*"
            [(ngModel)]="buttonURL" (input)="onChangeUrlButton($event.target.value)">
        </div>
      </div>


      <div class="blockC spinput" *ngIf="Snumber">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
        <br *ngIf="selectedFolderID==0">
        <div>Add Value</div>
        <div class="xrow spinput">
          <input type="text" value="$" [(ngModel)]="text" (keypress)="numberOnly($event)"
            (input)="onChangeNumberValue($event.target.value)" />
        </div>

      </div>

      <div class="blockC">

        <div class="xrow txtarea flex-d-col ">
          <div class="lab mb-0">Calculation Expression
            <mat-checkbox color="primary" style="margin-left: 8px; " [(ngModel)]="isDollar"
              (change)="onChangeDollarValue($event)">$
            </mat-checkbox>
          </div>
          <textarea [(ngModel)]="expression" (input)="onChangeExpression($event.target.value)"></textarea>
        </div>


        <div class="lab mb-0">Control ID</div>
        <label>{{ControlId}}</label>



      </div>


      <div class="blockC" *ngIf="Sinitials || Sdate || Simage">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
      </div>
      <div class="blockC" *ngIf="Sformat">
        <div class="lab">Formatting</div>
        <div class="xrow mtb5 sizenfont">

          <mat-form-field appearance="outline" class="fsize">
            <mat-label>Font Size</mat-label>
            <mat-select [(ngModel)]="fontsize" (selectionChange)="onChangeFontSize($event)">
              <mat-option *ngFor="let font of fontSize" [value]="font.fontsize">
                {{font.fontsize}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" class="fontfam">
            <mat-label>Font Family</mat-label>
            <mat-select [(ngModel)]="fontfamily" (selectionChange)="onChangeFontFamily($event)">
              <mat-option *ngFor="let fam of fontfamilys" [value]="fam.font">
                {{fam.font}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="yrow iconsAll">

          <div class="mb-10">
            <mat-button-toggle-group #group="matButtonToggleGroup">
              <mat-button-toggle value="left" aria-label="Text align left" mat-icon-button
                [ngClass]="{active : textalign == 'left'}" (click)="onChangeTextAlign('left')">
                <mat-icon>format_align_left</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="center" aria-label="Text align center"
                [ngClass]="{active : textalign == 'center'}" (click)="onChangeTextAlign('center')">
                <mat-icon>format_align_center</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="right" aria-label="Text align right" [ngClass]="{active : textalign == 'right'}"
                (click)="onChangeTextAlign('right')">
                <mat-icon>format_align_right</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="justify" aria-label="Text align justify"
                [ngClass]="{active : textalign == 'justify'}" (click)="onChangeTextAlign('justify')">
                <mat-icon>format_align_justify</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>


          <div class="mb-10">
            <mat-button-toggle-group #group2="matButtonToggleGroup">
              <mat-button-toggle value="left" aria-label="Text Bold" [ngClass]="{active : fontstyle === 'bold'}"
                (click)="onChangeTextBoldFont('bold')">
                <mat-icon>format_bold</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="center" aria-label="Text Italic" [ngClass]="{active : fontweight === 'italic'}"
                (click)="onChangeTextItalicFont('italic')">
                <mat-icon>format_italic</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="right" aria-label="Text Underline"
                [ngClass]="{active : textdecoration === 'underline'}" (click)="onChangeTextDecoration('underline')">
                <mat-icon>format_underlined</mat-icon>
              </mat-button-toggle>
              <mat-button-toggle value="justify" aria-label="Text Strike Through"
                [ngClass]="{active : textdecoration === 'line-through'}"
                (click)="onChangeTextDecoration('line-through')">
                <mat-icon>strikethrough_s</mat-icon>
              </mat-button-toggle>
            </mat-button-toggle-group>
          </div>

        </div>

        <div class="xrow">

        </div>

        <div class="xrow tcolor">
          <div class="txtColor">
            <div class="textViewColor" [ngStyle]="{'background':textColor}"></div>
            <input type="color" class="" [(ngModel)]="textColor" (input)="onChangeFontColor($event.target.value)" />
          </div>
          <span>font color</span>
        </div>

      </div>

      <div class="blockC" *ngIf="Sdraw || Ssignature">
        <div>Field Name <input type="text" [(ngModel)]="editFieldname"
            (input)="onChangeFieldName($event.target.value)" />


        </div>
        <div class="lab">Draw</div>
        <div class="xrow tcolor">
          <div class="textViewColor" [ngStyle]="{'background':'rgba(' + brushColor + ')'}"></div>
          <input type="color" class="" [(ngModel)]="brushColor" (input)="onBrushColorChange($event.target.value)" />
          <span>Select color</span>
        </div>
      </div>

      <div class="blockC" *ngIf="Smeasure">
        <div class="lab">Rotate</div>
        <input type="number" min="0" max="360" placeholder="Rotate by degrees" [(ngModel)]="rotationByDegree"
          (ngModelChange)="onRotationValueChange()" />
      </div>

      <div class="blockC xyposition" *ngIf="Simage">
        <div class="lab">Image dimensions</div>
        <div class="xrow mtb5">
          <div class="pos">Width<input type="text" value="100px" (input)="onChangeImageWidth($event.target.value)" />
          </div>
          <div class="pos">Height<input type="text" value="100px" (input)="onChangeImageHeight($event.target.value)" />
          </div>
        </div>
      </div>

      <div class="blockC xyposition" *ngIf="ShighLight">

        <div class="xrow tcolor">
          <div class="txtColor">
            <div class="textViewColor" [ngStyle]="{'background':'rgba(' + highLightColor + ')'}"></div>
            <input type="color" class="" [(ngModel)]="highLightColor"
              (input)="onChangeBackgroundColor($event.target.value)" />
          </div>
          <span>High Light Color</span>
        </div>



      </div>

      <!-- <div *ngIf="SAItext" class="blockC" >
      <button mat-stroked-button color="primary" (click)="hideControls()" >Hide Editor Controls</button>      
    </div> -->


      <div class="blockC" *ngIf="SAItext">


        <div class="lab">Add Question</div>
        <div class="xrow txtarea" style="position: relative;">
          <textarea [(ngModel)]="text" (keyup)="onKeyUp($event)" (input)="onChangeTextAIQestion($event.target.value)"
            (click)="updateCursorPosition($event)"></textarea>

          <!-- <div class="cusotomDropdown" *ngIf="showDropdown">
            <ul>
              <li (click)="selectValue('One')">One</li>
              <li (click)="selectValue('Two')">Two</li>
              <li (click)="selectValue('Three')">Three</li>
              <li (click)="selectValue('Four')">Four</li>
            </ul>
          </div> -->

          <div class="cusotomDropdown" *ngIf="showDropdown">

            <input class="custom-material-input" [(ngModel)]="aifilterfieldSearch" matInput (keyup)="filterList($event)"
              placeholder="Type to search...">
            <ul>
              <li class="field" *ngFor=" let field of aICoreFields " (click)="selectValue(field)">
                <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}</li>
              <!-- <li (click)="selectValue('Three')">Three</li>
              <li (click)="selectValue('Four')">Four</li>
              <li (click)="selectValue('One')">One</li>
              <li (click)="selectValue('Two')">Two</li>
              <li (click)="selectValue('Three')">Three</li>
              <li (click)="selectValue('Four')">Four</li>
              <li (click)="selectValue('One')">One</li>
              <li (click)="selectValue('Two')">Two</li>
              <li (click)="selectValue('Three')">Three</li>
              <li (click)="selectValue('Four')">Four</li> -->
            </ul>
            <!-- <mat-form-field appearance="fill">
              <mat-label>Select Type</mat-label>
              <mat-select (selectionChange)="getAllCoreSubfolderFields($event.value)" name="selectedCorePeopleType">
                <mat-option *ngFor="let subFolder of coreSubFolderList" [value]="subFolder.subFolderID">
                  {{ subFolder.folderName }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <mat-card class="field" 
              [ngStyle]="{'background-color': 'rgba(' + colorselected + ')'}" *ngFor=" let field of corefieldsList "
              (click)="selectValue(field)"
              >
              <mat-icon>{{field.fieldIcon}}</mat-icon>{{field.fieldName}}
            </mat-card> -->
          </div>


        </div>


        <div class="pageSearch">
          <label>AI Document Search</label>
          <input type="text" [(ngModel)]="Pagenumbers" class="pageNumber" placeholder="Enter page number">
          <p>Note:- Specify Page numbers for AI reading. If left blank, default search is first 5 pages</p>
        </div>

        <button class="runAI" mat-stroked-button color="primary" matTooltip="Run AI" mat-button
          (click)="GetResponseFromAIDoc(selectedAIDocs)">
          Run AI
        </button>

      </div>

      <div class="blockC" *ngIf="SAItext">

        <div>
          <ng-container *ngFor="let document of selectedAIDocs">


            <span class="documentList">
              <div class="userpic">
                <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
              </div>
              <div class="info">
                <a href="{{document.documentPath}}" target="_blank"> {{document.documentName}}</a>
                <button matTooltip="Unmap document" mat-icon-button (click)="DeleteAIDocuments(document)">
                  <mat-icon>delete</mat-icon>
                </button>

              </div>
            </span>
          </ng-container>
        </div>



        <div class="upDoc aiUploader">
          <div class="uploadholder">
            <input #Input type="file" multiple (change)="selectFilesFromDragZone($event)" />
            Drag and drop files here
          </div>
        </div>


        <button mat-flat-button (click)="selectDocuments(selectDocumentsId)">
          <mat-icon>remove_red_eye</mat-icon>
          View and map documents
        </button>


      </div>


      <div class="blockC xyposition">
        <div class="lab">Position</div>
        <div class="xrow mtb5">
          <div class="pos">x<input type="text" (keypress)="numberOnly($event)"
              (input)="onChangeXposition($event.target.value)" [ngModel]="xposition" /></div>
          <div class="pos">y<input type="text" (keypress)="numberOnly($event)"
              (input)="onChangeYposition($event.target.value)" [ngModel]="yposition" /></div>
        </div>
      </div>

    </div>

    <div class="blockC xyposition">
      <button mat-stroked-button color="warn" (click)="deleteSelectedControl()">Delete</button>
    </div>


  </mat-card>


  <mat-card class="mappingDetail" [ngClass]="{'open': showMappingDetail, 'openInDevice': openInDevice}">

    <div class="fieldMappingWrapper">

      <!-- <div class="fieldHolder">
        <h3>Document Field</h3>
        <div class="fieldList">
          Name
        </div>
        <div class="fieldList">
          Name
        </div>
      </div>
      <div class="fieldHolder">
        <h3>Our Field</h3>
      </div>
      <div class="fieldHolder">
        <h3>Import Field</h3>
      </div> -->

      <table>
        <tr>
          <th>Document Field</th>
          <th>Our Field</th>
          <th>Import Field</th>
        </tr>
        <tr>
          <td>Name</td>
          <td>
            <input type="text">
          </td>
          <td>
            Name
          </td>
        </tr>
      </table>



    </div>


  </mat-card>


</div>

<ng-template #selectDocumentsId>
  <h2 mat-dialog-title>
    <!-- <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span> -->
    Select Document

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <span *ngIf="showDocumentsToselectInPopup.length==0">
      Currently, there are no documents available for mapping. We kindly request you to upload a document that requires
      mapping for further processing and analysis.
    </span>
    <ul class="selectedlist">
      <li *ngFor="let document of showDocumentsToselectInPopup">
        <span (click)="MapDocToControls(document)" class="documentList">
          <div class="userpic">
            <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
          </div>
          <div class="info">
            <!-- <a href="{{document.documentPath}}" target="_blank">  -->
            {{document.documentName}}
            <!-- </a> -->

            <!-- <button mat-icon-button (click)="DeleteAIDocuments(document)">
                <mat-icon>delete</mat-icon>
              </button> -->

          </div>
        </span>
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #addAssigne>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Select & Add Participant

    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="searchBY">
      <mat-radio-group aria-label="Select an option" color="primary">
        <mat-radio-button value="1">By Name</mat-radio-button>
        <mat-radio-button value="2">By Email</mat-radio-button>
        <mat-radio-button value="3">By Role</mat-radio-button>
      </mat-radio-group>
    </div>

    <app-contactlist></app-contactlist>

    <ul class="selectedlist">
      <li *ngFor="let user of peoples">
        <div class="userndetail">
          <div class="pic">
            <img src="../../../assets/images/avatars/{{ user.img }}" alt="" />
          </div>
          <div class="detail">
            <div class="info">
              <p>
                {{ user.name }} <span class="email"> {{ user.email }}</span>
              </p>
              <p class="role">{{ user.role }}</p>
            </div>
          </div>
        </div>
        <button mat-icon-button>
          <mat-icon>cancel</mat-icon>
        </button>
      </li>
    </ul>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #Newfolder>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create_new_folder</mat-icon>
    </span>
    Folder Name
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <form class="example-form">
      <mat-form-field class="example-full-width">
        <mat-label>Folder Name</mat-label>
        <input matInput placeholder="Enter Folder Name" value="" />
      </mat-form-field>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Create</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #NewMultiSelectPopup>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create_new_folder</mat-icon>
    </span>
    Select Items
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="allControls">

      <div class="items">
        <span>Select New Items</span>

        <ng-container *ngFor="let m of multiSelectCurrentItem.fillList">
          <label (click)="AddMultiSelectItem(m.val,multiSelectCurrentItem)"> {{m.val}} </label>
        </ng-container>
      </div>
      <div class="show_icon">
        <mat-icon>sync_alt</mat-icon>
      </div>
      <div class="items selected">
        <span>Selected Items</span>

        <ng-container *ngFor="let s of multiSelectCurrentItem.selectedValue;">
          <label (click)="removeMultiSelectItem(s,multiSelectCurrentItem)"> {{s}}</label>
        </ng-container>

        <ng-container *ngIf="multiSelectCurrentItem.selectedValue.length == 0">
          <p>No item selected</p>
        </ng-container>


      </div>
    </div>
  </mat-dialog-content>
</ng-template>
<ng-template #AIPdfpopUp>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>picture_as_pdf</mat-icon>
    </span>
    Run AI
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="upDoc aiUploader">
      <div class="uploadholder">
        <input #Input type="file" multiple
          (change)="selectFilesFromDragZoneOuter($event,aiDocListWithDetailForOuter)" />
        Drag and drop files here
      </div>



    </div>

    <ng-container *ngFor="let document of selectedAIDocsOUter">

      <span class="documentList mt-15">
        <div class="userpic">
          <img src="../../../../assets/icons/fileType/pdf_icon.svg" alt="">
        </div>
        <div class="info">
          <a href="{{document.documentPath}}" target="_blank"> {{document.documentName}}</a>
        </div>
      </span>
    </ng-container>

    <div class="singleQuestion" *ngFor="let qs of aiDocListWithDetailForOuter; index as i ">

      <h4>Q{{i+1}}: {{qs.question}}</h4>

      <button class="runAI" mat-stroked-button color="primary" matTooltip="Run AI" mat-button
        (click)="GetResponseFromAIDocOuter(qs)">
        Run AI
      </button>

      <mat-icon *ngIf="qs.isCompleted==true">check_circle</mat-icon>

    </div>


  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="basic" (click)="close()">Close</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #ConvertPdfpopUp>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>picture_as_pdf</mat-icon>
    </span>
    Generate PDF
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="genOpts">

      <p>Generated documents will automatically save on their selected location.</p>

      <button mat-stroked-button color="primary" (click)="ConvertPdf(false)">Generate & Continue</button>
      <button mat-stroked-button color="primary" (click)="ConvertPdf(true)">Generate & Exit</button>

    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button color="basic" (click)="close()">Close</button>
  </mat-dialog-actions>
</ng-template>


<ng-template #docPreview>
  <app-doc-preview [modifiedParticipantJson]="imagesWithFields" [pagesList]="thumbsList"></app-doc-preview>
</ng-template>

<ng-template #relation>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>group_add</mat-icon>
    </span>
    Add Relations Under Group 1
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">

    <app-contactlist></app-contactlist>

    <ul class="selectedlist">
      <li>
        <div class="userndetail">
          <div class="detail">
            <h4>Doctor</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
      <li>
        <div class="userndetail">
          <div class="detail">
            <h4>Nurse</h4>
          </div>
          <div class="opt">
            <button mat-icon-button>
              <mat-icon>cancel</mat-icon>
            </button>
          </div>
        </div>
      </li>
    </ul>

  </mat-dialog-content>
  <mat-dialog-actions>

    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button color="primary">Done</button>
  </mat-dialog-actions>
</ng-template>


<app-create-fillable-fields (closeSlide)="closecreateField($event)" [ngClass]="{ open: showSidePanel }">
</app-create-fillable-fields>

<ng-template #AddSignature>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>create</mat-icon>
    </span>
    Add Signature
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">

      <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
          <mat-radio-button value="draw" (change)="radioChangeSign()">Draw</mat-radio-button>
          <mat-radio-button value="upload" (change)="radioChangeSign()">Upload</mat-radio-button>
          <mat-radio-button value="type" (change)="radioChangeSign()">Type In</mat-radio-button>
        </mat-radio-group>
      </div>



      <div class="allSCont">
        <ng-container *ngIf="signOpt == 'upload'">
          <div class="uploadholder">
            <mat-icon>note_add</mat-icon>
            <p *ngIf="filenameForSign == '' ">Drop your signature here or click here to upload</p>
            <span *ngIf="filenameForSign == '' ">File extension should be .png</span>
            <p>{{filenameForSign}}</p>
            <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
              placeholder="Add file">
          </div>
        </ng-container>

        <ng-container *ngIf="signOpt == 'draw'">
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
        </ng-container>

        <ng-container *ngIf="signOpt == 'type'">
          <div class="divideCol">
            <div class="left blk">
              <mat-form-field>
                <mat-label>Enter Name</mat-label>
                <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                  (ngModelChange)="signOrInitialTextChanges($event)">
              </mat-form-field>
            </div>
            <div class="right blk">
              <mat-form-field appearance="fill">
                <mat-label>Select font family</mat-label>
                <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                  <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="allSign">
            <div class="signlook" [ngStyle]="{'font-family': selected}">
              {{signName}}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <span>
      <button mat-stroked-button color="primary" *ngIf="signaturePad != undefined"
        (click)="clearSignature()">Clear</button>
      <button mat-flat-button (click)="addSignature()" color="primary" [disabled]="!SignButtonEnable">Sign</button>
    </span>
  </mat-dialog-actions>
</ng-template>

<ng-template #Draw>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>brush</mat-icon>
    </span>
    Draw
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">




      <div class="allSCont">

        <ng-container>
          <signature-pad id="drawCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
            (onEndEvent)="drawComplete()"></signature-pad>
        </ng-container>


      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addDrawnImg()" color="primary">Draw</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #DrawInPopup>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>brush</mat-icon>
    </span>
    Draw
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">




      <div class="allSCont">

        <ng-container>
          <!-- <signature-pad id="drawCanvas" [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad> -->
          <image-drawing [width]="500" [height]="500" borderCss="1px solid black" [showCancelButton]="false"
            [enableLoadAnotherImage]="true" [enableRemoveImage]="true"
            src="https://jaipuria.edu.in/kanpurschool/wp-content/uploads/2019/05/kanpur_school_registration_form.jpg"
            (save)="saveBtn($event)" [i18n]="i18n" [locale]="locale"
            [drawingSizes]="{small:5,medium:10,large:25,extra:50}"></image-drawing>
        </ng-container>


      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addDrawnImg()" color="primary">Draw</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #AddInitial>
  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>gesture</mat-icon>
    </span>
    Add Initials
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <div class="tabConainer">
      <div class="radOpts">
        <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
          <mat-radio-button value="draw" (change)="radioChangeInitails()">Draw</mat-radio-button>
          <mat-radio-button value="upload" (change)="radioChangeInitails()">Upload</mat-radio-button>
          <mat-radio-button value="type" (change)="radioChangeInitails()">Type In</mat-radio-button>
        </mat-radio-group>
      </div>



      <div class="allSCont">
        <ng-container *ngIf="signOpt == 'upload'">
          <div class="uploadholder">
            <mat-icon>note_add</mat-icon>
            <p>Drop your initials here or click here to upload</p>
            <span>File extension should be .png</span>
            <input type="file" class="form-control" accept="image/*" (change)="onSelectSignImage($event,'','')"
              placeholder="Add file">
          </div>
        </ng-container>

        <ng-container *ngIf="signOpt == 'draw'">
          <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()">
          </signature-pad>
        </ng-container>

        <ng-container *ngIf="signOpt == 'type'">
          <div class="divideCol">
            <div class="left blk">
              <mat-form-field>
                <mat-label>Enter Name</mat-label>
                <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName"
                  (ngModelChange)="signOrInitialTextChanges($event)">
              </mat-form-field>
            </div>
            <div class="right blk">
              <mat-form-field appearance="fill">
                <mat-label>Select font family</mat-label>
                <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                  <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}">{{fam.font}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
          <div class="allSign">
            <div class="signlook" [ngStyle]="{'font-family': selected}">
              {{signName}}
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="close()">Cancel</button>
    <button mat-flat-button (click)="addSignature()" color="primary" [disabled]="!InitailButtonEnable">Sign</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #fillForm>
  <!-- <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>text_snippet</mat-icon>
    </span>
    Fill Form
    <button mat-icon-button (click)="cancelFillForm()">
      <mat-icon>close</mat-icon>
    </button> 
   </h2> -->
  <mat-dialog-content class="mat-typography">
    <!-- <button mat-icon-button (click)="cancelFillForm()">
      <mat-icon>close</mat-icon>
    </button>  -->
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start"
      (selectedTabChange)="getTabDetailsForFillForm($event)">
      <mat-tab label="Data From 3C">
        <div *ngIf="showDataFrom3C==true">
          <div class="autoFill">

            <button *ngIf="!autoFill" class="autoFIllBtn" mat-flat-button color="primary" (click)="onAutoFillChanged($event)">
              <mat-icon>checklist</mat-icon> Auto fill values
            </button>

            <button *ngIf="autoFill" mat-flat-button color="primary" (click)="onAutoFillChanged($event)">
              <mat-icon>check_circle</mat-icon> Auto fill values
            </button>

          </div>
          <mat-accordion class="signaccor" multi>
            <mat-expansion-panel *ngIf='particiantJsonListAutoFill.length>0 && groupRelationParticipantId!="0"'
              [expanded]="openPanel===1">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Contact
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div style="overflow-y: auto;" *ngFor="let item of particiantJsonListAutoFill;let i= index;">
                <ng-container *ngFor="let field of filedsForFillForm(item.fields);let j= index;">
                  <ng-container *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>0 && field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
                    && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">
                    <div class="iframe-resize-container"
                      [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"
                      [ngClass]="{'ng-show-required' : field.showRequiredControls}"
                      (click)="verifyParticipant(field,$event)" *ngIf="!field.isDisabled">
                      <div class="iframe-drag-handle" (click)="addActiveClass(field,null,$event)"
                        [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}" [attr.field]="field.id"
                        [attr.tabIndex]="setTabIndex(i,j)" #dragHandle>
                        <ng-container *ngIf="field.fieldTypeName=='Textbox'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}}</mat-label>
                              <input matInput [ngModelOptions]="{standalone: true}" maxlength="150"
                                (input)="onChange($event.target.value,item,field)" type="text"
                                [(ngModel)]='field.selectedValue' id="{{field.id}}" placeholder="{{field.fieldName}}"
                                (click)="OpentoolDetail('Textbox')" (click)="OpentoolDetailText(item,field.id,$event)">
                            </mat-form-field>
                          </form>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Textarea'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}}</mat-label>
                              <textarea matInput [attr.maxLength]="field.charLimit" [innerHtml]='field.selectedValue'
                                (input)="onChangeTexarea($event.target.value,item,field)"
                                (click)="OpentoolDetail('Textarea')" class="form-control" id="{{field.id}}"
                                placeholder="{{field.fieldName}}" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                (click)="OpentoolDetailText(item,field.id,$event)"></textarea>
                            </mat-form-field>
                          </form>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Number'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}}</mat-label>
                              <input matInput [(ngModel)]='field.selectedValue' [ngModelOptions]="{standalone: true}"
                                type="text" class="form-control" id="{{field.id}}"
                                (input)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Number')"
                                (keypress)="numberOnly($event)" id="{{field.id}}"
                                (click)="OpentoolDetailText(item,field.id,$event)">
                            </mat-form-field>
                          </form>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Dropdown'">
                          <mat-form-field>
                            <mat-label>Select {{field.placeholder}}</mat-label>
                            <mat-select id="{{field.id}}" [ngStyle]="{
                                    'color': field.fontColor,
                                    'text-align': field.textalign,
                                    'font-weight': field.fontstyle,
                                    'font-style': field.fontweight,
                                    'font-size': field.fontSize,
                                    'font-family': field.fontfamily
                                    }" [disabled]="field.isDisabled" (click)="OpentoolDetail('Dropdown')"
                              (click)="OpentoolDetailDropDown(item,field.id,$event)"
                              (selectionChange)="setDdlValue($event,item,field)" [(ngModel)]="field.selectedValue"
                              [attr.value]="field.selectedValue" placeholder={{field.selectedValue}}>
                              <mat-option [ngStyle]="{
                                    'color': field.fontColor,
                                    'text-align': field.textalign, 
                                    'font-weight': field.fontstyle, 
                                    'field-style': field.fontweight,  
                                    'font-size': field.fontSize, 
                                    'font-family': field.fontfamil}" *ngFor="let drp of field.fillList"
                                [value]="drp.val">
                                {{ drp.val }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='MultiSelect'">
                          <mat-form-field>
                            <mat-label>Select {{field.placeholder}}</mat-label>
                            <mat-select id="{{field.id}}" [ngStyle]="{
                                  'color': field.fontColor, 
                                  'text-align': field.textalign, 
                                  'font-weight': field.fontstyle, 
                                  'font-style': field.fontweight, 
                                  'font-size': field.fontSize, 
                                  'font-family': field.fontfamily
                                  }" color="primary" [ngModel]="field.selectedValue"
                              (selectionChange)="setDdlValue($event,item,field)" (click)="OpentoolDetail('MultiSelect')"
                              (click)="OpentoolDetailMulDropDown(item,field.id,$event)" [required]='field.isRequired'
                              multiple>
                              <mat-option *ngFor="let muldrp of field.fillList" [value]="muldrp.val">
                                {{ muldrp.val }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Currency'">
                          <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily
                           ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}" type="text"
                            [(ngModel)]='field.selectedValue' (input)="onChange($event.target.value,item,field)"
                            class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}"
                            (click)="OpentoolDetail('Number')" (click)="OpentoolDetailText(item,field.id,$event)">
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='URL'">
                          <input
                            [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"
                            type="text" [value]='field.selectedValue' (input)="onChange($event.target.value,item,field)"
                            (click)="OpentoolDetail('URL')" (click)="OpentoolDetailText(item,field.id,$event)"
                            class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}">
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Address'">
                          <input
                            [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"
                            type="text" class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}"
                            [value]='field.selectedValue'>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='City'">
                          <mat-form-field>
                            <mat-label>City</mat-label>
                            <input class="form-control"
                              [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                              'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                              placeholder="{{field.fieldName}}" type="text" id="{{field.id}}"
                              placeholder="{{field.placeholder}}" [(ngModel)]='field.selectedValue' matInput
                              (input)="searchCity($event.target.value,item,field.id)" [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="cityselected($event,item,field.id)">
                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='State'">
                          <mat-form-field>
                            <mat-label>Select State</mat-label>
                            <mat-select id="{{field.id}}" [ngStyle]="{
                                  'color': field.fontColor,
                                  'text-align': field.textalign,
                                  'font-weight': field.fontstyle,
                                  'font-style': field.fontweight,
                                  'font-size': field.fontSize,
                                  'font-family': field.fontfamily
                                  }" [disabled]="field.isDisabled" (click)="OpentoolDetail('Dropdown')"
                              (click)="OpentoolDetailDropDown(item,field.id,$event)"
                              (selectionChange)="setDdlValue($event,item,field)" [(ngModel)]="field.selectedValue"
                              placeholder={{field.selectedValue}}>
                              <mat-option>None</mat-option>
                              <mat-option [ngStyle]="{
                                  'color': field.fontColor,
                                  'text-align': field.textalign, 
                                  'font-weight': field.fontstyle, 
                                  'field-style': field.fontweight,  
                                  'font-size': field.fontSize, 
                                  'font-family': field.fontfamil}" *ngFor="let state of stateList" [value]="state">
                                {{ state }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Zip'">
                          <mat-form-field>
                            <mat-label>Zip Code</mat-label>
                            <input class="form-control"
                              [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                              'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                              placeholder="{{field.fieldName}}" type="text" id="{{field.id}}"
                              placeholder="{{field.placeholder}}" [(ngModel)]='field.selectedValue' matInput
                              (input)="onChange($event.target.value,item,field)"
                              (input)="searchZip($event.target.value,item,field.id)" [matAutocomplete]="auto">
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="zipselected($event,item,field.id)">
                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Location'">
                          <div id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Location')"
                            (click)="fetchLocation(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                            <span *ngIf='!field.Lat && !field.Long'>
                              <mat-icon>location_on</mat-icon>
                              Location
                            </span>
                            <ng-container *ngIf='field.Lat && field.Long'>
                              <h3
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}">
                                Lat : {{field.Lat}}
                                Long: {{field.Long}}
                              </h3>
                            </ng-container>

                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Date'">
                          <div class="Dtime">
                            <mat-form-field>
                              <input id="{{field.id}}" matInput type="text"
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                           'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"
                                [ngModel]="field.selectedValue |date:'yyyy-MM-dd'" placeholder="{{field.fieldName}}"
                                (input)="onChange($event.target.value,item,field)" readonly
                                (dateChange)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Date')"
                                (click)="OpentoolDetailText(item,field.id,$event)" [matDatepicker]="basicDatepicker" />
                              <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                              <mat-datepicker #basicDatepicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Time'">
                          <div class="Dtime" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                            <input id="{{field.id}}" type="text"
                              [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                              aria-label="default time" [ngxTimepicker]="toggleTimepicker"
                              (click)="OpentoolDetail('Time')" (click)="OpentoolDetailText(item,field.id,$event)"
                              matInput placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue' readonly>
                            <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker">
                            </ngx-material-timepicker-toggle>
                            <ngx-material-timepicker (timeSet)="onChange($event,item,field)" #toggleTimepicker>
                            </ngx-material-timepicker>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='File'">
                          <div class="customUpdate" (click)="OpentoolDetail('File')" id="{{field.id}}"
                            (click)="OpentoolDetailText(item,field.id,$event)"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="cloud_upload" *ngIf='field.FileData.length==0'>
                              <mat-icon>cloud_upload</mat-icon>
                              Upload File
                            </span>
                            <div *ngFor="let file of field.FileData" class="uploadedData">
                              <p>{{file.FullPath}}</p>
                            </div>
                            <input type="file" class="form-control" id="{{field.fieldName}}"
                              (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Signature'">
                          <div id="{{field.id}}" class="customUpdate"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}" (click)="OpentoolDetail('Signature')"
                            (click)="OpenSignPopup(AddSignature,item,field,$event)">
                            <span id="border_color"
                              *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                              <mat-icon>border_color</mat-icon>
                              Signature
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                              <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                            </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              <img [src]="img.Imageurl"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Draw'">
                          <div id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')"
                            (click)="OpenDrawPopup(Draw,item,field,field.id)"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Drawpopup'">
                          <div id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')"
                            (click)="OpenDrawInPopup(DrawInPopup, null, null)">
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Initials'">
                          <div id="{{field.id}}" class="customUpdate"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}" (click)="OpentoolDetail('Initials')"
                            (click)="OpenSignPopup(AddInitial,item,field,$event)">
                            <span id="initial_gesture"
                              *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                              <mat-icon>gesture</mat-icon>
                              Initials
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                              <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                            </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              <img [src]="img.Imageurl"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Button'">
                          <a [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                            class="btn-primary btnGlobal" id="{{field.id}}" href="{{field.buttonURL}}" target="_blank"
                            (click)="OpentoolDetail('Button')"
                            (click)="OpentoolDetailText(item,field.id,$event)">{{field.buttonName}}</a>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>0 && field.fieldTypeName=='Checkbox' || field.fieldTypeName=='Radio' ||
                field.fieldTypeName=='CheckBoxGroup'">
                    <div class="radioHolder" id="{{field.id}}" *ngIf="!field.isDisabled">
                      <div *ngFor="let ele of field.fillList; let i=index" class="iframe-resize-container"
                        [attr.field]="field.id" [ngClass]="{'ng-show-required' : field.showRequiredControls}"
                        (click)="verifyParticipant(field,$event)">
                        <div class="iframe-drag-handle" [attr.field]="field.id" #dragHandle
                          [attr.tabIndex]="setTabIndex(i,j)">
                          <ng-container *ngIf="field.fieldTypeName=='Checkbox'">
                            <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                      }" class="checkboxfield" (click)="OpentoolDetail('Checkbox')"
                              (click)="OpentoolDetailCheckBox(item,field.id,ele.id,$event)">
                              <input type="checkbox" class="mat-checkbox-input"
                                [checked]='ifChkCheckedAutoFill(field,item,ele.id)'
                                (click)="OnChangeCheckBox($event, ele.val, field,item,ele.id)">
                              {{ele.val}}
                            </label>
                          </ng-container>
                          <ng-container *ngIf="field.fieldTypeName=='Radio'">
                            <div class="flexCol" id="{{field.id}}">
                              <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                      }" class="radiofield" (click)="OpentoolDetail('Radio')"
                                (click)="OpentoolDetailRadioButtonGroup(item,field.id,ele.id,$event)">
                                <input type="radio" class="mat-checkbox-input"
                                  [attr.Checked]="ifRadioChecked(field.id,item,ele.id)? 'checked' : null"
                                  name='{{field.id}}' [checked]='ifRadioChecked(field.id,item,ele.id)' [value]="ele.val"
                                  (change)="OnChangeRadio($event, ele.val, field.id,item,ele.id)">
                                {{ele.val}}
                              </label>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="field.fieldTypeName=='CheckBoxGroup'">
                            <div class="flexCol" id="{{field.id}}">
                              <label
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                class="checkboxfield" (click)="OpentoolDetail('CheckBoxGroup')"
                                (click)="OpentoolDetailCheckBoxGroup(item,field.id,ele.id,$event)">
                                <input class="mat-checkbox-input" type="checkbox"
                                  [attr.checked]="ifChkChecked(field.id,item,ele.id)? 'checked' : null"
                                  [checked]='ifChkChecked(field.id,item,ele.id)'
                                  (change)="OnChangeCheckBoxGroup($event, ele.val, field.id,item,ele.id)">
                                {{ele.val}}
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>0 && field.fieldTypeName=='Image'">
                    <div class="radioHolder" id="{{field.id}}" *ngIf="!field.isDisabled">
                      <div *ngFor="let ele of field.fillList; let i=index" class="iframe-resize-container"
                        [attr.field]="field.id" [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}"
                        [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" style="position: absolute"
                        (click)="verifyParticipant(field,$event)">
                        <div class="iframe-drag-handle" (click)="addActiveClass(field,null,$event)"
                          [attr.field]="field.id" [attr.tabIndex]="setTabIndex(i,j)"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}" #dragHandle>
                          <ng-container *ngIf="field.fieldTypeName=='Image'">
                            <div class="customUpdate" (click)="OpentoolDetail('Image')" id="{{field.id}}"
                              (click)="OpentoolDetailText(item,field.id,$event)"
                              [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                              [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                              [ngClass]="{'ng-show-required' : field.showRequiredControls}">
                              <span id="cloud_upload" *ngIf='field.ImageData.length==0'>
                                <mat-icon>cloud_upload</mat-icon>
                                Upload Image
                              </span>
                              <div *ngFor="let img of field.ImageData" class="uploadedData">
                                <img *ngIf='img.Imageurl' [src]="img.Imageurl"
                                  [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" />
                              </div>
                              <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}"
                                (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </mat-expansion-panel>
            <mat-expansion-panel *ngIf='particiantJsonListAutoFillCore.length>0' [expanded]="openPanel===2">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  Core
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div style="overflow-y: auto;" *ngFor="let item of particiantJsonListAutoFillCore;let i= index;">
                <ng-container *ngFor="let field of filedsForFillForm(item.fields);let j= index;">
                  <ng-container *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>-1 && field.fieldTypeName!=='Checkbox' && field.fieldTypeName!=='Radio'
                    && field.fieldTypeName!=='CheckBoxGroup' && field.fieldTypeName!=='Image'">
                    <div class="iframe-resize-container"
                      [ngClass]="{'fileControl' :field.fieldTypeName=='Draw' || field.fieldTypeName=='Signature' || field.fieldTypeName=='Initials'  }"
                      (click)="verifyParticipant(field,$event)" *ngIf="!field.isDisabled">
                      <div class="iframe-drag-handle" (click)="addActiveClass(field,null,$event)"
                        [ngStyle]="{'transform':'rotate('+field.rotation+'deg)'}" [attr.field]="field.id"
                        [attr.tabIndex]="setTabIndex(i,j)" #dragHandle>
                        <ng-container *ngIf="field.fieldTypeName=='Textbox'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup
                                  *ngIf="field.showRequiredControls">*</sup></mat-label>
                              <input matInput [ngModelOptions]="{standalone: true}" maxlength="150"
                                (input)="onChange($event.target.value,item,field)" type="text"
                                [(ngModel)]='field.selectedValue' id="{{field.id}}" placeholder="{{field.fieldName}}"
                                (click)="OpentoolDetail('Textbox')" (click)="OpentoolDetailText(item,field.id,$event)">
                            </mat-form-field>
                          </form>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Textarea'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup
                                  *ngIf="field.showRequiredControls">*</sup></mat-label>
                              <textarea matInput [attr.maxLength]="field.charLimit" [innerHtml]='field.selectedValue'
                                (input)="onChangeTexarea($event.target.value,item,field)"
                                (click)="OpentoolDetail('Textarea')" class="form-control" id="{{field.id}}"
                                placeholder="{{field.fieldName}}" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                                (click)="OpentoolDetailText(item,field.id,$event)"></textarea>
                            </mat-form-field>
                          </form>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Number'">
                          <form class="fillformOpt">
                            <mat-form-field class="example-full-width">
                              <mat-label>{{formatSubfolderName(field.subFolderName)}} {{field.fieldName}} <sup
                                  *ngIf="field.showRequiredControls">*</sup></mat-label>
                              <input matInput [(ngModel)]='field.selectedValue' [ngModelOptions]="{standalone: true}"
                                type="text" class="form-control" id="{{field.id}}"
                                (input)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Number')"
                                (keypress)="numberOnly($event)" id="{{field.id}}"
                                (click)="OpentoolDetailText(item,field.id,$event)">
                            </mat-form-field>
                          </form>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Dropdown'">
                          <mat-form-field>
                            <mat-label>Select {{field.placeholder}} <sup *ngIf="field.showRequiredControls">*</sup>
                            </mat-label>
                            <mat-select id="{{field.id}}" [ngStyle]="{
                                    'color': field.fontColor,
                                    'text-align': field.textalign,
                                    'font-weight': field.fontstyle,
                                    'font-style': field.fontweight,
                                    'font-size': field.fontSize,
                                    'font-family': field.fontfamily
                                    }" [disabled]="field.isDisabled" (click)="OpentoolDetail('Dropdown')"
                              (click)="OpentoolDetailDropDown(item,field.id,$event)"
                              (selectionChange)="setDdlValue($event,item,field)" [(ngModel)]="field.selectedValue"
                              [attr.value]="field.selectedValue" placeholder={{field.selectedValue}}>
                              <mat-option [ngStyle]="{
                                    'color': field.fontColor,
                                    'text-align': field.textalign, 
                                    'font-weight': field.fontstyle, 
                                    'field-style': field.fontweight,  
                                    'font-size': field.fontSize, 
                                    'font-family': field.fontfamil}" *ngFor="let drp of field.fillList"
                                [value]="drp.val">
                                {{ drp.val }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='MultiSelect'">
                          <mat-form-field>
                            <mat-label>Select {{field.placeholder}} <sup *ngIf="field.showRequiredControls">*</sup>
                            </mat-label>
                            <mat-select id="{{field.id}}" [ngStyle]="{
                                  'color': field.fontColor, 
                                  'text-align': field.textalign, 
                                  'font-weight': field.fontstyle, 
                                  'font-style': field.fontweight, 
                                  'font-size': field.fontSize, 
                                  'font-family': field.fontfamily
                                  }" color="primary" [ngModel]="field.selectedValue"
                              (selectionChange)="setDdlValue($event,item,field)" (click)="OpentoolDetail('MultiSelect')"
                              (click)="OpentoolDetailMulDropDown(item,field.id,$event)" [required]='field.isRequired'
                              multiple>
                              <mat-option *ngFor="let muldrp of field.fillList" [value]="muldrp.val">
                                {{ muldrp.val }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Currency'">
                          <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily
                           ,'width': field.offsetWidth+'px','height': field.offsetHeight+'px'}" type="text"
                            [(ngModel)]='field.selectedValue' (input)="onChange($event.target.value,item,field)"
                            class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}"
                            (click)="OpentoolDetail('Number')" (click)="OpentoolDetailText(item,field.id,$event)">
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='URL'">
                          <input
                            [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"
                            type="text" [value]='field.selectedValue' (input)="onChange($event.target.value,item,field)"
                            (click)="OpentoolDetail('URL')" (click)="OpentoolDetailText(item,field.id,$event)"
                            class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}">
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Address'">
                          <input
                            [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"
                            type="text" class="form-control" id="{{field.id}}" placeholder="{{field.placeholder}}">
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='City'">
                          <mat-form-field>
                            <mat-label>City</mat-label>
                            <input [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                              'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                             }" placeholder="{{field.fieldName}}" type="text" id="{{field.id}}"
                              placeholder="{{field.placeholder}}" [(ngModel)]='field.selectedValue'                            
                              (input)="searchCity($event.target.value,item,field.id)" [matAutocomplete]="auto" matInput>
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="cityselected($event,item,field.id)">
                              <mat-option *ngFor="let option of cityOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='State'">
                          <mat-form-field>
                            <mat-label>Select State</mat-label>
                            <mat-select id="{{field.id}}" [ngStyle]="{
                                  'color': field.fontColor,
                                  'text-align': field.textalign,
                                  'font-weight': field.fontstyle,
                                  'font-style': field.fontweight,
                                  'font-size': field.fontSize,
                                  'font-family': field.fontfamily
                                  }" [disabled]="field.isDisabled" (click)="OpentoolDetail('Dropdown')"
                              (click)="OpentoolDetailDropDown(item,field.id,$event)"
                              (selectionChange)="setDdlValue($event,item,field)" [(ngModel)]="field.selectedValue"
                              placeholder={{field.selectedValue}}>
                              <mat-option>None</mat-option>
                              <mat-option [ngStyle]="{
                                  'color': field.fontColor,
                                  'text-align': field.textalign, 
                                  'font-weight': field.fontstyle, 
                                  'field-style': field.fontweight,  
                                  'font-size': field.fontSize, 
                                  'font-family': field.fontfamil}" *ngFor="let state of stateList" [value]="state">
                                {{ state }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Zip'">
                          <mat-form-field>
                            <mat-label>Zip Code</mat-label>
                            <input class="form-control"
                              [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight,
                              'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                              placeholder="{{field.fieldName}}" type="text" id="{{field.id}}"
                              placeholder="{{field.placeholder}}" [(ngModel)]='field.selectedValue'
                              (input)="onChange($event.target.value,item,field)"
                              (input)="searchZip($event.target.value,item,field.id)" [matAutocomplete]="auto" matInput>
                            <mat-autocomplete #auto="matAutocomplete"
                              (optionSelected)="zipselected($event,item,field.id)">
                              <mat-option *ngFor="let option of zipOption" [value]="option">
                                {{option}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Location'">
                          <div id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Location')"
                            (click)="fetchLocation(item,field.id)" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                            <span *ngIf='!field.Lat && !field.Long'>
                              <mat-icon>location_on</mat-icon>
                              Location
                            </span>
                            <ng-container *ngIf='field.Lat && field.Long'>
                              <h3
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}">
                                Lat : {{field.Lat}}
                                Long: {{field.Long}}
                              </h3>
                            </ng-container>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Date'">
                          <div class="Dtime">
                            <mat-form-field>
                              <input id="{{field.id}}" matInput type="text"
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 
                           'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize , 'font-family': field.fontfamily}"
                                [ngModel]="field.selectedValue |date:'yyyy-MM-dd'" placeholder="{{field.fieldName}}"
                                (input)="onChange($event.target.value,item,field)" readonly
                                (dateChange)="onChange($event.target.value,item,field)" (click)="OpentoolDetail('Date')"
                                (click)="OpentoolDetailText(item,field.id,$event)" [matDatepicker]="basicDatepicker" />
                              <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                              <mat-datepicker #basicDatepicker></mat-datepicker>
                            </mat-form-field>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Time'">
                          <div class="Dtime" [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}">
                            <input id="{{field.id}}" type="text"
                              [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                              aria-label="default time" [ngxTimepicker]="toggleTimepicker"
                              (click)="OpentoolDetail('Time')" (click)="OpentoolDetailText(item,field.id,$event)"
                              matInput placeholder="{{field.fieldName}}" [(ngModel)]='field.selectedValue' readonly>
                            <ngx-material-timepicker-toggle matSuffix [for]="toggleTimepicker">
                            </ngx-material-timepicker-toggle>
                            <ngx-material-timepicker (timeSet)="onChange($event,item,field)" #toggleTimepicker>
                            </ngx-material-timepicker>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='File'">
                          <div class="customUpdate" (click)="OpentoolDetail('File')" id="{{field.id}}"
                            (click)="OpentoolDetailText(item,field.id,$event)"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="cloud_upload" *ngIf='field.FileData.length==0'>
                              <mat-icon>cloud_upload</mat-icon>
                              Upload File
                            </span>
                            <div *ngFor="let file of field.FileData" class="uploadedData">
                              <p>{{file.FullPath}}</p>
                            </div>
                            <input type="file" class="form-control" id="{{field.fieldName}}"
                              (change)="onSelectFile($event,item,field.id)" placeholder="{{field.fieldName}}">
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Signature'">
                          <div id="{{field.id}}" class="customUpdate"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}" (click)="OpentoolDetail('Signature')"
                            (click)="OpenSignPopup(AddSignature,item,field,$event)">
                            <span id="border_color"
                              *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                              <mat-icon>border_color</mat-icon>
                              Signature
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                              <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                            </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              <img [src]="img.Imageurl"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Draw'">
                          <div id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw')"
                            (click)="OpenDrawPopup(Draw,item,field,field.id)"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}">
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Drawpopup'">
                          <div id="{{field.id}}" class="customUpdate" (click)="OpentoolDetail('Draw1')"
                            (click)="OpenDrawInPopup(DrawInPopup,null,null)">
                            <span id="draw_brush" *ngIf='!field.drawBase64  && field.ImageData.length==0'>
                              <mat-icon>brush</mat-icon>
                              Draw
                            </span>
                            <img *ngIf='field.drawBase64' [src]="field.drawBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Initials'">
                          <div id="{{field.id}}" class="customUpdate"
                            [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                            [ngClass]="{'ng-active' : field.ShowtoolDetail}" (click)="OpentoolDetail('Initials')"
                            (click)="OpenSignPopup(AddInitial,item,field,$event)">
                            <span id="initial_gesture"
                              *ngIf='!field.signatureBase64 && !field.signatureText && field.ImageData.length==0'>
                              <mat-icon>gesture</mat-icon>
                              Initials
                            </span>
                            <img *ngIf='field.signatureBase64' [src]="field.signatureBase64"
                              [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            <ng-container *ngIf='field.signatureText && !field.signatureBase64'>
                              <h3 [ngStyle]="{'font-family': field.signInitialFontFamily}">{{field.signatureText}}</h3>
                            </ng-container>
                            <div *ngFor="let img of field.ImageData" class="uploadedData">
                              <img [src]="img.Imageurl"
                                [ngStyle]="{'height': field.offsetHeight +'px', 'width': field.offsetWidth +'px'}" />
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="field.fieldTypeName=='Button'">
                          <a [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                            class="btn-primary btnGlobal" id="{{field.id}}" href="{{field.buttonURL}}" target="_blank"
                            (click)="OpentoolDetail('Button')"
                            (click)="OpentoolDetailText(item,field.id,$event)">{{field.buttonName}}</a>
                        </ng-container>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>-1 && field.fieldTypeName=='Checkbox' || field.fieldTypeName=='Radio' ||
                field.fieldTypeName=='CheckBoxGroup'">
                    <div class="radioHolder" id="{{field.id}}" *ngIf="!field.isDisabled">
                      <div *ngFor="let ele of field.fillList; let i=index" class="iframe-resize-container"
                        [attr.field]="field.id" [ngClass]="{'ng-show-required' : field.showRequiredControls}"
                        (click)="verifyParticipant(field,$event)">
                        <div class="iframe-drag-handle" [attr.field]="field.id" #dragHandle
                          [attr.tabIndex]="setTabIndex(i,j)">
                          <ng-container *ngIf="field.fieldTypeName=='Checkbox'">
                            <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                      }" class="checkboxfield" (click)="OpentoolDetail('Checkbox')"
                              (click)="OpentoolDetailCheckBox(item,field.id,ele.id,$event)">
                              <input type="checkbox" class="mat-checkbox-input"
                                [checked]='ifChkCheckedAutoFill(field,item,ele.id)'
                                (click)="OnChangeCheckBox($event, ele.val, field,item,ele.id)">
                              {{ele.val}}
                            </label>
                          </ng-container>
                          <ng-container *ngIf="field.fieldTypeName=='Radio'">
                            <div class="flexCol" id="{{field.id}}">
                              <label [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily
                      }" class="radiofield" (click)="OpentoolDetail('Radio')"
                                (click)="OpentoolDetailRadioButtonGroup(item,field.id,ele.id,$event)">
                                <input type="radio" class="mat-checkbox-input"
                                  [attr.Checked]="ifRadioChecked(field.id,item,ele.id)? 'checked' : null"
                                  name='{{field.id}}' [checked]='ifRadioChecked(field.id,item,ele.id)' [value]="ele.val"
                                  (change)="OnChangeRadio($event, ele.val, field.id,item,ele.id)">
                                {{ele.val}}
                              </label>
                            </div>
                          </ng-container>
                          <ng-container *ngIf="field.fieldTypeName=='CheckBoxGroup'">
                            <div class="flexCol" id="{{field.id}}">
                              <label
                                [ngStyle]="{'color': field.fontColor, 'text-align': field.textalign, 'font-weight': field.fontstyle, 'font-style': field.fontweight, 'text-decoration': field.textdecoration, 'font-size': field.fontSize, 'font-family': field.fontfamily}"
                                class="checkboxfield" (click)="OpentoolDetail('CheckBoxGroup')"
                                (click)="OpentoolDetailCheckBoxGroup(item,field.id,ele.id,$event)">
                                <input class="mat-checkbox-input" type="checkbox"
                                  [attr.checked]="ifChkChecked(field.id,item,ele.id)? 'checked' : null"
                                  [checked]='ifChkChecked(field.id,item,ele.id)'
                                  (change)="OnChangeCheckBoxGroup($event, ele.val, field.id,item,ele.id)">
                                {{ele.val}}
                              </label>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container
                    *ngIf="field.selectedParticipant?.groupRelationParticipantMappingID>-1 && field.fieldTypeName=='Image'">
                    <div class="radioHolder" id="{{field.id}}" *ngIf="!field.isDisabled">
                      <div *ngFor="let ele of field.fillList; let i=index" class="iframe-resize-container"
                        [attr.field]="field.id" [ngClass]="{'fileControl' :field.fieldTypeName=='Image'}"
                        [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" style="position: absolute"
                        (click)="verifyParticipant(field,$event)">
                        <div class="iframe-drag-handle" (click)="addActiveClass(field,null,$event)"
                          [attr.field]="field.id" [attr.tabIndex]="setTabIndex(i,j)"
                          [ngClass]="{'ng-active' : field.ShowtoolDetail}" #dragHandle>
                          <ng-container *ngIf="field.fieldTypeName=='Image'">
                            <div class="customUpdate" (click)="OpentoolDetail('Image')" id="{{field.id}}"
                              (click)="OpentoolDetailText(item,field.id,$event)"
                              [ngStyle]="{'border': '2px solid rgb(' + convertRBA2RGB(field.colorCode) + ')'}"
                              [ngClass]="{'ng-active' : field.ShowtoolDetail}"
                              [ngClass]="{'ng-show-required' : field.showRequiredControls}">
                              <span id="cloud_upload" *ngIf='field.ImageData.length==0'>
                                <mat-icon>cloud_upload</mat-icon>
                                Upload Image
                              </span>
                              <div *ngFor="let img of field.ImageData" class="uploadedData">
                                <img *ngIf='img.Imageurl' [src]="img.Imageurl"
                                  [ngStyle]="{'height': field.Imageheight, 'width': field.Imagewidth}" />
                              </div>
                              <input type="file" class="form-control" accept="image/*" id="{{field.fieldName}}"
                                (change)="onSelectImage($event,item,field.id)" placeholder="{{field.fieldName}}">
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </ng-container>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </div>

      </mat-tab>

      <mat-tab label="Data From My Drive">
        <div class="myforms" *ngIf="showDataFromMyDrive==true">
          <div class="drive mainLink">



            <div class="folderName" (click)="GetAllMyDrive()">
              <mat-icon class="type">account_balance</mat-icon>
              My Drive
            </div>

            <mat-tree [dataSource]="dataSourceFileManager" [treeControl]="treeControlFileManager">
              <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
                *matTreeNodeDef="let node" matTreeNodePadding matTreeNodePaddingIndent="20">
                <div class="folderRow">
                  <mat-icon class="mat-icon-rtl-mirror arrowIcon" style="visibility: hidden;">
                    arrow_right
                  </mat-icon>

                  <div class="folderName">
                    <mat-icon class="folder" *ngIf="node.isShared == false"
                      (click)="showChildFolders(node)">folder</mat-icon>
                    <mat-icon class="folder" *ngIf="node.isShared == true"
                      (click)="showChildFolders(node)">folder_shared</mat-icon>
                    <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
                  </div>
                </div>
              </mat-tree-node>

              <mat-tree-node [ngClass]="{ 'active': activeNodeFileManager === node.fileManagerItemID }"
                *matTreeNodeDef="let node;when: hasChild" matTreeNodePadding matTreeNodePaddingIndent="20">
                <div class="folderRow" matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name">
                  <mat-icon class="mat-icon-rtl-mirror arrowIcon">
                    {{treeControl.isExpanded(node) ? 'arrow_drop_down' : 'arrow_right'}}
                  </mat-icon>
                  <div class="folderName">
                    <mat-icon class="folder" *ngIf="node.isShared == false"
                      (click)="showChildFolders(node)">folder</mat-icon>
                    <mat-icon class="folder" *ngIf="node.isShared == true"
                      (click)="showChildFolders(node)">folder_shared</mat-icon>
                    <span class="flname" (click)="showChildFolders(node)">{{node.name}}</span>
                  </div>
                </div>

              </mat-tree-node>
            </mat-tree>

            <div class="folderName" (click)="getSharedWithMeMyDrive()"
              [ngClass]="{ 'active': SharedWithMeMyDriveactive }">
              <mat-icon class="type">portrait</mat-icon> Shared with me
            </div>

          </div>

          <div class="driveDetail" *ngIf="isShowMyDrive">

            <mat-card class="files">
              <mat-form-field appearance="fill">
                <mat-label>Search File & Folder... </mat-label>
                <input matInput type="text" [(ngModel)]="searchKey" (keyup)="$event.keyCode == 13
                      ? Search($event.target.value)
                      : $event.target.value == ''
                      ? Search($event.target.value)
                      : null" />
                <button [disabled]="searchKey == ''" matSuffix mat-icon-button aria-label="Clear">
                  <mat-icon (click)="SearchFilter()">search</mat-icon>
                </button>
              </mat-form-field>

              <div class="breadcumb pl-5 pr-5">
                <span (click)="breadCrumbMyDriveMainClick()">My Drive</span>
                <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
                  <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
                  <a (click)="breadCrumbMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
                </span>
              </div>


              <table class="mat-table">
                <thead>
                  <tr class="mat-header-row">
                    <th class="mat-header-cell wstar">&nbsp; </th>
                    <th class="mat-header-cell wstar"></th>
                    <!-- <th class="mat-header-cell wstar"></th> -->
                    <th class="mat-header-cell">Name</th>
                    <th class="mat-header-cell pro">Status</th>
                    <th class="mat-header-cell date">Created On</th>
                    <th class="mat-header-cell date">Modified On</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let form of MyDrivefoldersList; let i = index;">
                    <tr class="mat-row foldericon" (click)="radioChangeMyDrive(form)">
                      <td class="mat-cell wstar">
                        <span class="checkbo" *ngIf="form.isFile == true">
                          <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                            (change)="radioChangeMyDrive(form)"></mat-radio-button>
                        </span>
                      </td>

                      <!-- <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                        <td class="mat-cell">
                          <mat-icon class="fav">grade</mat-icon>
                        </td>
                      </ng-container>
    
                      <ng-template #showFavorite>
                        <td class="mat-cell">
                          <mat-icon class="star">grade</mat-icon>
                        </td>
                      </ng-template> -->

                      <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == false">
                        <mat-icon>folder</mat-icon>
                      </td>

                      <td class="mat-cell docType" *ngIf="form.isFile == false && form.isShared == true">
                        <mat-icon>folder_shared</mat-icon>
                      </td>

                      <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                        <ng-container *ngIf="form.fileType == 'pdf'">
                          <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg"
                            alt="Pdf File" />
                        </ng-container>
                        <ng-container *ngIf="form.fileType == 'png'">
                          <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                        </ng-container>
                        <ng-container *ngIf="form.fileType == 'jpg'">
                          <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                        </ng-container>
                        <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                          description
                        </mat-icon>
                      </td>

                      <td class="mat-cell" *ngIf="form.isFile == false">
                        <span class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip"
                          matTooltip="{{form.name}}">{{ form.name }}</span>
                      </td>

                      <td class="mat-cell" *ngIf="form.isFile == true">
                        <p class="formName" matTooltipClass="tooltip" matTooltipClass="tooltip"
                          matTooltip="{{form.name}}">
                          {{ form.name }}</p>
                        <span *ngIf="form.fileSize" class="fileSize">{{ form.fileSize }}</span>
                      </td>

                      <td class="mat-cell pro">
                        <mat-icon class="processed"
                          *ngIf="form.fileType == 'pdf' && form.vectorFileID">check_circle</mat-icon>
                        <mat-icon class="notProcessed" *ngIf="form.fileType == 'pdf' && !form.vectorFileID"
                          (click)="processDocumentToVectorDB(form)">restore_page</mat-icon>
                      </td>

                      <td class="mat-cell">
                        {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                      </td>

                      <td class="mat-cell" *ngIf="form.updatedOn!=null">
                        {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                      </td>

                      <td class="mat-cell" *ngIf="form.updatedOn==null">
                        {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                      </td>

                    </tr>
                  </ng-container>

                  <ng-container *ngIf="foldersMyDriveListShow">
                    <tr>
                      <td colspan="7">
                        <p class="nocontent">No Items Found</p>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </mat-card>
          </div>

          <div class="driveDetail" *ngIf="isSharedWithMeMyDrive">
            <div class="breadcumb">
              <span (click)="breadCrumbMainSHaredWithMeMyDriveClick()">Shared with me</span>
              <span *ngFor="let m of menuHeaderMyDrive;let i= index;">
                <mat-icon class="sidenav-breaddiv">keyboard_arrow_right</mat-icon>
                <a (click)="breadCrumbSharedWithMeMyDrive(menuHeaderMyDrive, i)">{{ m.label }}</a>
              </span>
            </div>

            <mat-card class="files">
              <table class="mat-table">
                <thead>
                  <tr class="mat-header-row">
                    <th class="mat-header-cell wstar">&nbsp; </th>
                    <th class="mat-header-cell wstar"></th>
                    <th class="mat-header-cell wstar"></th>
                    <th class="mat-header-cell">Name</th>
                    <th class="mat-header-cell" *ngIf="parentID==0">Shared By</th>
                    <th class="mat-header-cell date">Created On</th>
                    <th class="mat-header-cell date">Modified On</th>
                  </tr>
                </thead>
                <tbody>
                  <ng-container *ngFor="let form of SharedWithMeMyDriveFolderList; let i = index;">
                    <tr class="mat-row foldericon" (click)="radioChangeMyDriveSharedWithMe(form)">
                      <td class="mat-cell wstar">
                        <span class="checkbo" *ngIf="form.isFile == true">
                          <mat-radio-button color="primary" value="i" [checked]="form.isChecked"
                            (change)="radioChangeMyDriveSharedWithMe(form)">

                          </mat-radio-button>
                        </span>
                      </td>

                      <ng-container *ngIf="getIsFavorite(form) == true; else showFavorite">
                        <td class="mat-cell">
                          <mat-icon class="fav">grade</mat-icon>
                        </td>
                      </ng-container>

                      <ng-template #showFavorite>
                        <td class="mat-cell">
                          <mat-icon class="star">grade</mat-icon>
                        </td>
                      </ng-template>

                      <td class="mat-cell docType" *ngIf="form.isFile == false">
                        <mat-icon>folder</mat-icon>
                      </td>

                      <td class="mat-cell formIcon" *ngIf="form.isFile == true">
                        <ng-container *ngIf="form.fileType == 'pdf'">
                          <img class="fileIcon" src="../../../../../assets/icons/fileType/pdf_icon.svg"
                            alt="Pdf File" />
                        </ng-container>
                        <ng-container *ngIf="form.fileType == 'png'">
                          <img class="fileIcon" src="../../../../../assets/icons/fileType/020-png.svg" alt="png File" />
                        </ng-container>
                        <ng-container *ngIf="form.fileType == 'jpg'">
                          <img class="fileIcon" src="../../../../../assets/icons/fileType/014-jpg.svg" alt="jpg File" />
                        </ng-container>
                        <mat-icon *ngIf="form.fileType != 'pdf' && form.fileType != 'png' && form.fileType != 'jpg'">
                          description
                        </mat-icon>
                      </td>

                      <td class="mat-cell" *ngIf="form.isFile == false">
                        <span class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name
                          }}</span>
                      </td>

                      <td class="mat-cell" *ngIf="form.isFile == true">
                        <p class="formName" matTooltipClass="tooltip" matTooltip="{{form.name}}">{{ form.name }}</p>
                        <span *ngIf="form.fileSize" class="fileSize">{{ form.fileSize }}</span>
                      </td>

                      <td class="mat-cell" *ngIf="parentID==0">
                        <span class="formName" matTooltipClass="tooltip">
                          {{ form.sharedbyFirstName }} {{ form.sharedbyLastName }}
                        </span>
                      </td>

                      <td class="mat-cell">
                        {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                      </td>

                      <td class="mat-cell" *ngIf="form.updatedOn!=null">
                        {{ form.updatedOn+'Z' | date: "MM/dd/yyyy" }}
                      </td>

                      <td class="mat-cell" *ngIf="form.updatedOn==null">
                        {{ form.createdOn+'Z' | date: "MM/dd/yyyy" }}
                      </td>

                    </tr>
                  </ng-container>

                  <ng-container *ngIf="SharedWithMeMyDriveFolderList.length==0">
                    <tr>
                      <td colspan="7">
                        <p class="nocontent">No Items Found</p>
                      </td>
                    </tr>
                  </ng-container>
                </tbody>
              </table>
            </mat-card>
          </div>

        </div>
      </mat-tab>
    </mat-tab-group>

    <!-- <mat-radio-group color="primary" aria-label="Select an option">
      <mat-radio-button value="0" style="margin-right: 15px;" (change)="OnChangeFormFill(1)">Data From 3C</mat-radio-button>
      <mat-radio-button value="2" style="margin-right: 15px;" (change)="OnChangeFormFill(2)">Data From My Drive</mat-radio-button>     
    </mat-radio-group>
    <br> -->


  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-stroked-button (click)="cancelFillForm()">Cancel</button>
    <!-- <button *ngIf="showDataFrom3C==true" mat-stroked-button (click)="cancelFillForm()">Cancel</button> -->
    <button *ngIf="showDataFrom3C==true" mat-flat-button color="primary" (click)="close()">Done</button>
  </mat-dialog-actions>
</ng-template>




<app-bind-field-forms [ngClass]="{ open: openbindFieldsDetail }" (bindFieldViewer)="getAIDetail($event)"
  (closeBindEmit)="getCloseBindFieldDetail()" [folderID]="folderID" [modulename]="Module"
  [mainModulename]="mainModuleNameForms" (selectedRecord)=updateFieldMappingJson($event)>
</app-bind-field-forms>

<style>
  .cke_notifications_area {
    display: none;
  }
</style>

<style>
  .cke_notification {
    display: none;
  }
</style>
<style>
  .cke_notification_warning {
    display: none;
  }
</style>
<style>
  .cke_notification cke_notification_warning {
    display: none !important;
  }
</style>